import React, { useEffect, useState } from 'react'
// import * as supplierService from "../../service/fleet-management/supplierService";
import * as supplierService from "../../service/fleet-management/supplierService";
import * as driverService from "../../service/fleet-management/driverService";
import * as localStorageService from "../../service/localStorageService"
import { useNavigate, useParams } from "react-router-dom";
import { Row, Col, Card, Dropdown, Modal, Form, DatePicker, Input, Button, Select, Spin, Typography } from 'antd';
import { useStore } from '../../store/store';
import { UploadOutlined, PlusOutlined, DeleteFilled } from "@ant-design/icons";
import DriverGruardImg from '../../assets/images/driver-guard-img.svg'
import pencilEdit from '../../assets/images/supplier-pencil-edit.svg'
import { CommonConstants, DocTypes, EntityTypes, OwnerType } from '../../constants/commonConstants';
import { useTranslation } from "react-i18next";
import * as masterDataService from "../../service/masterDataService";
import { CheckCircleOutlined, MoreOutlined } from '@ant-design/icons';
import AlertCircle from "../../assets/images/alert-circle.svg";
import Arrowdown from "../../assets/images/arrow-down-dropdown.svg";
import Notifications from "../../service/notification";
import { validateNotEmpty, validateEmail } from '../../util/inputValidateUtils';
import * as documentUtility from "../../util/documentThumbUtility";
import * as documentService from "../../service/documentService";
import { checkIsFleetOwner, checkIsSTO, checkIsCountryPresent, checkIsTurkeyKazak, checkIsFleetOwnerOrBroker, checkIsSTOorBroker, checkIsFleetOwnerConverted, removeUniquenessCheckForCountry } from "../../util/constantUtility";
import ExistsImg from "../../assets/images/exists img.svg"
import Fileupload from "../../common/fileupload/fileupload";
import ExclamatoryMark from "../../assets/images/exclamation_mark_red.svg"
import "./supplier-details.scss"
import dayjs from 'dayjs';
import Notification from "../../service/notification";
import moment from 'moment';
import { getMinAndMaxLengthForMobileNumber } from '../../util/countryWiseMobileNumberUtils';
import { LocalStorageKeys } from '../../constants/localStorageKeys';
import * as otpService from "../../service/otpService";
import WriterBlock from "../../assets/images/writers_block.svg"
import RequestToFleetOwnerC from './request-to-fleetowner-C';
import OCRFilePreviewUploader from "../../common/ocr-file-preview-uploader/ocr-file-preview-uploader";
import fileSearchGif from "../../assets/images/file-search.gif";
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
const { Title, Paragraph } = Typography;


export default function SupplierDetails() {
    const { executeRecaptcha } = useGoogleReCaptcha();
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [formValues, setFormValues] = useState({});
    const { supplierId } = useParams();
    const [editSupplierForm] = Form.useForm();
    const [isUploadImage, setIsUploadImage] = useState(false);
    const [detailData, setdetailData] = useState();
    const [supplierDocs, setSupplierDocs] = useState();
    const [uploadImageForm] = Form.useForm();
    const [countryOptions, setCountryOptions] = useState();
    const [imageUploadLoader, setImageUploadLoader] = useState(false);
    const [countriesListWaiter, setCountriesListWaiter] = useState(false);
    const [frontDocs, setFrontDocs] = useState({});
    const { user, saveUser } = useStore();
    const [loader, setloader] = useState(false)
    const [issuingCountriesListWaiter, setIssuingCountriesListWaiter] = useState(false);
    const [ibanNumber, setIbanNumber] = useState([""]);
  const [saveProfileLoader, setSaveProfileLoader] = useState(false);


    const [isbtnLoader, setBtnLoader] = useState(false)
    const [isDisableOtpAction,setIsDisableOtpAction]=useState(true);
    const [minMaxMobileNoLength, setMinMaxMobileNoLength] = useState(getMinAndMaxLengthForMobileNumber());
    const [isEditModalOpen, setIsEditModalOpen] = useState(false)
    const [isLoadingSupplierDetail,setIsLoadingSupplierDetail]=useState(true);
    const defaultVisaDoc = {
        index: 0,
        documentNumber: "",
        issuingCountry: "",
        expiryDate: "",
        frontDoc: {
            isInsertUpdate: false,
            isPathSet: true,
            documentPath: "",
            documentPathThumb: "",
            fileName: "",
        }
    }
    const [visaArray, setVisaArray] = useState([{ ...defaultVisaDoc }]);
    const [visa, setVisa] = useState([{ ...defaultVisaDoc }]);
    const [otpDetails, setOtpDetails] = useState(null)
    const language = localStorageService.getValue(LocalStorageKeys.Lang) ? localStorageService.getValue(LocalStorageKeys.Lang) : CommonConstants.DefaultLanguageCode;
    console.log(visa, "visa")
    const format = 'DD/MM/YYYY';
    const navigate = useNavigate();
    const [timer, setTimer] = useState(120);
    const [isOTPRequested, setIsOtpRequested] = useState(false);
    const [verifyModal, setVerifyModal] = useState(false);
    const [showDrawer, setShowDrawer] = useState(false);
    const [buttonNameChange, setbuttonNameChange] = useState();

    // ******************* OCR File Uploads STATES *****************
    const initialUploadState = {
    progress: 0,
    status: "Hold Tight - File is Being Prepared Securely.",
    description: "Please don’t close or refresh the screen",
    started: false,
    };
    // const [ownerType, setOwnerType] = useState(null);
    const ownerType = detailData?.userRole || null;
    console.log("ownerType", ownerType);
    const [ocrLogId, setOcrLogId] = useState("");
    const [isOcrFileUpload, setIsOcrFileUpload] = useState(false);
    const [ocrParsedData, setOcrParsedData] = useState(null);
    console.log("ocrParsedData", ocrParsedData);
    const [isUploadingPopupVisible, setIsUploadingPopupVisible] = useState(false);
    const [uploadState, setUploadState] = useState(initialUploadState);
    console.log("uploadState", uploadState);

    const [editSupplierDocs, setEditSupplierDocs] = useState();
    console.log("editSupplierDocs supplierDetail", editSupplierDocs);

    // ********************* *******************

    useEffect(() => {
        supplierDetail();
        getCountries();
    }, [])

    useEffect(() => {
        let interval;
        if (isOTPRequested && timer > 0) {
            interval = setInterval(() => {
                setTimer((prevTimer) => prevTimer - 1);
            }, 1000);
        }

        if (timer === 0) {
            clearInterval(interval);
        }

        return () => clearInterval(interval);
    }, [isOTPRequested, timer]);

    const getCountries = () => {
        setCountriesListWaiter(true);
        masterDataService

            .getCountryMaster()
            .then((res) => {
                setCountriesListWaiter(false);
                if (res.status === 200) {
                    setCountryOptions(res.data);
                    let countries = [];
                    user?.dataProtectionDetail?.country?.forEach((ele) => {
                        countries.push(ele);
                    });
                    user?.dataProtectionDetail?.externalShipperMasterIds?.forEach(
                        (ele) => {
                            if (!countries?.includes(ele.country)) {
                                countries.push(ele.country);
                            }
                        }
                    );
                    let localCountries = res.data.filter(
                        (ele) => countries?.indexOf(ele.name) !== -1
                    );
                    // setCountries(localCountries);
                }
            })
            .catch((err) => {
                setCountriesListWaiter(false);
            });
    };
    const supplierDetail = () => {
        setIsLoadingSupplierDetail(true);
        supplierService.getAccountDetails(supplierId)
            .then((response) => {
                // setBtnLoader(false);
                setdetailData(response?.data?.data);
                setIsLoadingSupplierDetail(false);
                // fillUserDetail(response);
                // console.log(detailData,'account')
            }).catch(error=>{
                setIsLoadingSupplierDetail(false);
            })

        supplierService.getSupplierKycInfo(supplierId).then((response) => {
            const data = response?.data?.data;
            setSupplierDocs(data);  // Store the response data
            setVisaArray(data?.visa || []);
            setIbanNumber(data?.iBanNo || [])
            if (data?.iBanNo?.length > 0) {
                data.iBanNo.forEach((item, index) => {
                    editSupplierForm.setFieldValue(`iBanNo_${index}`, item);
                })
            }
        })
            .catch((error) => {
                // setBtnLoader(false);
            });
    }

    useEffect(() => {
        // if (supplierDocs) {
        //     const formattedValues = {
        //         passportFront: {
        //             FileName: supplierDocs.passport?.frontDoc?.fileName,
        //             FileURL: supplierDocs.passport?.frontDoc?.documentPath,
        //             FileThumbURL: supplierDocs.passport?.frontDoc?.documentPathThumb,
        //             isInsertUpdate: false
        //         },
        //         passportBack: {
        //             FileName: supplierDocs.passport?.backDoc?.fileName,
        //             FileURL: supplierDocs.passport?.backDoc?.documentPath,
        //             FileThumbURL: supplierDocs.passport?.backDoc?.documentPathThumb,
        //             isInsertUpdate: false
        //         },
        //         passportNumber: supplierDocs.passport?.documentNumber || null, // Added optional chaining
        //         passportExpiry: supplierDocs?.passport?.expiryDate
        //             ? moment(supplierDocs.passport.expiryDate).format(format)
        //             : null,

        //         nationalIdFront: {
        //             FileName: supplierDocs.nationalID?.frontDoc?.fileName,
        //             FileURL: supplierDocs.nationalID?.frontDoc?.documentPath,
        //             FileThumbURL: supplierDocs.nationalID?.frontDoc?.documentPathThumb,
        //             isInsertUpdate: false
        //         },
        //         nationalIdBack: {
        //             FileName: supplierDocs.nationalID?.backDoc?.fileName,
        //             FileURL: supplierDocs.nationalID?.backDoc?.documentPath,
        //             FileThumbURL: supplierDocs.nationalID?.backDoc?.documentPathThumb,
        //             isInsertUpdate: false
        //         },
        //         nationalId: supplierDocs.nationalID?.documentNumber || null,
        //         nationalIdExpiry: supplierDocs.nationalID?.expiryDate
        //             ? moment(supplierDocs.nationalID.expiryDate).format(format)
        //             : null,
        //         licenceFront: {
        //             FileName: supplierDocs.drivingLicense?.frontDoc?.fileName,
        //             FileURL: supplierDocs.drivingLicense?.frontDoc?.documentPath,
        //             FileThumbURL: supplierDocs.drivingLicense?.frontDoc?.documentPathThumb,
        //             isInsertUpdate: false
        //         },
        //         licenceBack: {
        //             FileName: supplierDocs.drivingLicense?.backDoc?.fileName,
        //             FileURL: supplierDocs.drivingLicense?.backDoc?.documentPath,
        //             FileThumbURL: supplierDocs.drivingLicense?.backDoc?.documentPathThumb,
        //             isInsertUpdate: false
        //         },
        //         drivingLicenseNumber: supplierDocs.drivingLicense?.documentNumber || null,
        //         licenseExpiry: supplierDocs.drivingLicense?.expiryDate
        //             ? moment(supplierDocs.drivingLicense.expiryDate).format(format)
        //             : "null",

        //         vatUpload: {
        //             FileName: supplierDocs.vatCertificate?.frontDoc?.fileName,
        //             FileURL: supplierDocs.vatCertificate?.frontDoc?.documentPath,
        //             FileThumbURL: supplierDocs.vatCertificate?.frontDoc?.documentPathThumb,
        //             isInsertUpdate: false
        //         },
        //         vatExpiry: supplierDocs.vatCertificate?.expiryDate
        //             ? moment(supplierDocs.vatCertificate.expiryDate).format(format)
        //             : null,
        //         vatNumber: supplierDocs.vatCertificate?.documentNumber || null,
        //         iBanNo: supplierDocs.iBanNo || [],
        //         registrationOffice: supplierDocs.registrationOffice || null,
        //         certification: supplierDocs.certification || [],

        //         tradeFont:{
        //             FileName: supplierDocs.tradeLicense?.frontDoc?.fileName,
        //             FileURL: supplierDocs.tradeLicense?.frontDoc?.documentPath,
        //             FileThumbURL: supplierDocs.tradeLicense?.frontDoc?.documentPathThumb,
        //             isInsertUpdate: false
        //         },
        //         tradeDocumentNumber:supplierDocs.tradeLicense?.documentNumber || null,
        //         tradeExpiry: supplierDocs.tradeLicense?.expiryDate
        //         ? moment(supplierDocs.tradeLicense.expiryDate).format(format)
        //         : null,

        //         visa: supplierDocs?.visa,
        //     };
        //     const formattedVisa = supplierDocs?.visa?.map((val) => ({
        //         ...val,
        //         expiryDate: val?.expiryDate
        //             ? moment(val?.expiryDate).format(format)
        //             : null,
        //     })) || [];
        //     setVisa(formattedVisa);
        //     console.log(formattedValues, "qwerty");
        //     editSupplierForm.setFieldsValue(formattedValues);
        // }
        if (supplierDocs) {
            const formattedValues = {};

            // Passport
            if (supplierDocs.passport?.frontDoc?.fileName && supplierDocs.passport?.frontDoc?.documentPath) {
                formattedValues.passportFront = {
                    FileName: supplierDocs.passport?.frontDoc?.fileName,
                    FileURL: supplierDocs.passport?.frontDoc?.documentPath,
                    FileThumbURL: supplierDocs.passport?.frontDoc?.documentPathThumb,
                    isInsertUpdate: false
                };
            }

            if (supplierDocs.passport?.backDoc?.fileName && supplierDocs.passport?.backDoc?.documentPath) {
                formattedValues.passportBack = {
                    FileName: supplierDocs.passport?.backDoc?.fileName,
                    FileURL: supplierDocs.passport?.backDoc?.documentPath,
                    FileThumbURL: supplierDocs.passport?.backDoc?.documentPathThumb,
                    isInsertUpdate: false
                };
            }

            if (supplierDocs.passport?.documentNumber) {
                formattedValues.passportNumber = supplierDocs.passport?.documentNumber;
            }

            if (supplierDocs.passport?.expiryDate) {
                formattedValues.passportExpiry = moment(supplierDocs.passport.expiryDate).format(format);
            }

            // National ID
            if (supplierDocs.nationalID?.frontDoc?.fileName && supplierDocs.nationalID?.frontDoc?.documentPath) {
                formattedValues.nationalIdFront = {
                    FileName: supplierDocs.nationalID?.frontDoc?.fileName,
                    FileURL: supplierDocs.nationalID?.frontDoc?.documentPath,
                    FileThumbURL: supplierDocs.nationalID?.frontDoc?.documentPathThumb,
                    isInsertUpdate: false
                };
            }

            if (supplierDocs.nationalID?.backDoc?.fileName && supplierDocs.nationalID?.backDoc?.documentPath) {
                formattedValues.nationalIdBack = {
                    FileName: supplierDocs.nationalID?.backDoc?.fileName,
                    FileURL: supplierDocs.nationalID?.backDoc?.documentPath,
                    FileThumbURL: supplierDocs.nationalID?.backDoc?.documentPathThumb,
                    isInsertUpdate: false
                };
            }

            if (supplierDocs.nationalID?.documentNumber) {
                formattedValues.nationalId = supplierDocs.nationalID?.documentNumber;
            }

            if (supplierDocs.nationalID?.expiryDate) {
                formattedValues.nationalIdExpiry = moment(supplierDocs.nationalID.expiryDate).format(format);
            }

            // Driving License
            if (supplierDocs.drivingLicense?.frontDoc?.fileName && supplierDocs.drivingLicense?.frontDoc?.documentPath) {
                formattedValues.licenceFront = {
                    FileName: supplierDocs.drivingLicense?.frontDoc?.fileName,
                    FileURL: supplierDocs.drivingLicense?.frontDoc?.documentPath,
                    FileThumbURL: supplierDocs.drivingLicense?.frontDoc?.documentPathThumb,
                    isInsertUpdate: false
                };
            }

            if (supplierDocs.drivingLicense?.backDoc?.fileName && supplierDocs.drivingLicense?.backDoc?.documentPath) {
                formattedValues.licenceBack = {
                    FileName: supplierDocs.drivingLicense?.backDoc?.fileName,
                    FileURL: supplierDocs.drivingLicense?.backDoc?.documentPath,
                    FileThumbURL: supplierDocs.drivingLicense?.backDoc?.documentPathThumb,
                    isInsertUpdate: false
                };
            }

            if (supplierDocs.drivingLicense?.documentNumber) {
                formattedValues.drivingLicenseNumber = supplierDocs.drivingLicense?.documentNumber;
            }

            if (supplierDocs.drivingLicense?.expiryDate) {
                formattedValues.licenseExpiry = moment(supplierDocs.drivingLicense.expiryDate).format(format);
            }

            // VAT Certificate
            if (supplierDocs.vatCertificate?.frontDoc?.fileName && supplierDocs.vatCertificate?.frontDoc?.documentPath) {
                formattedValues.vatUpload = {
                    fileName: supplierDocs.vatCertificate?.frontDoc?.fileName,
                    fileUrl: supplierDocs.vatCertificate?.frontDoc?.documentPath,
                    fileThumbUrl: supplierDocs.vatCertificate?.frontDoc?.documentPathThumb,
                    isInsertUpdate: false
                };
            }

            if (supplierDocs.vatCertificate?.expiryDate) {
                formattedValues.vatExpiry = moment(supplierDocs.vatCertificate.expiryDate).format(format);
            }

            if (supplierDocs.vatCertificate?.documentNumber) {
                formattedValues.vatNumber = supplierDocs.vatCertificate?.documentNumber;
            }

            // IBAN Number
            if (supplierDocs.iBanNo && supplierDocs.iBanNo.length > 0) {
                formattedValues.iBanNo = supplierDocs.iBanNo;
            }

            // Registration Office
            if (supplierDocs.registrationOffice) {
                formattedValues.registrationOffice = supplierDocs.registrationOffice;
            }

            // Certification
            if (supplierDocs.certification && supplierDocs.certification.length > 0) {
                formattedValues.certification = supplierDocs.certification;
            }

            // Trade License
            if (supplierDocs.tradeLicense?.frontDoc?.fileName && supplierDocs.tradeLicense?.frontDoc?.documentPath) {
                formattedValues.tradeFont = {
                    fileName: supplierDocs.tradeLicense?.frontDoc?.fileName,
                    fileUrl: supplierDocs.tradeLicense?.frontDoc?.documentPath,
                    fileThumbUrl: supplierDocs.tradeLicense?.frontDoc?.documentPathThumb,
                    isInsertUpdate: false
                };
            }

            if (supplierDocs.tradeLicense?.documentNumber) {
                formattedValues.tradeDocumentNumber = supplierDocs.tradeLicense?.documentNumber;
            }

            if (supplierDocs.tradeLicense?.expiryDate) {
                formattedValues.tradeExpiry = moment(supplierDocs.tradeLicense.expiryDate).format(format);
            }

            // Visa
            if (supplierDocs?.visa && supplierDocs.visa.length > 0) {
                const formattedVisa = supplierDocs.visa.map((val, index) => {
                    editSupplierForm.setFieldValue(["visa", index, "issuingCountry"], val.issuingCountry);
                    return {
                        ...val,
                        expiryDate: val?.expiryDate ? moment(val?.expiryDate).format(format) : null,
                    }
                });
                setVisa(formattedVisa);
            }

            // Check for all non-null, non-empty fields and update the form only with valid data
            if (Object.keys(formattedValues).length > 0) {

                editSupplierForm.setFieldsValue(formattedValues);
            }
        }
    }, [supplierDocs]);

    const isTurkeyKazakhstanPresent =
        detailData?.operatingCountry === "Turkey" ||
        detailData?.operatingCountry === "Kazakhstan" ||
        !checkIsCountryPresent(detailData?.operatingCountry);

    // const handleVisaDocumentChange = (val, index, documentIndex) => {
    //     let localVisa = [...visa];
    //     localVisa[index].frontDoc = {
    //         fileName: val.FileName,
    //         documentPath: val.FileURL,
    //         documentPathThumb:
    //             val.FileThumbURL,
    //         isInsertUpdate: true,
    //     };
    //     // localVisa[index].document[documentIndex] = {
    //     //   documentPath: val.FileURL,
    //     //   documentPathThumb: val.FileThumbURL,
    //     //   fileName: val.FileName,
    //     //   isInsertUpdate: true,
    //     // };
    //     setVisa(localVisa);
    //     handleFormChange("visa", localVisa);
    // };
    // const addVisaDocument = (visaIndex) => {
    //     let localVisa = [...visa];

    //     localVisa[visaIndex].document.push({
    //         documentPath: "",
    //         documentPathThumb: "",
    //         fileName: "",
    //         isInsertUpdate: true,
    //     });
    //     setVisa(localVisa);
    //     handleFormChange("visa", localVisa);
    // };
    const handleMenuClick = (e) => {
        const payload = {
            externalSupplierId: detailData?.userId
        }
        supplierService.RemoveSupplierFromFleet(payload)
            .then((response) => {
                if (response.status === 200) {
                    setloader(true)
                    navigate("/view-fleet")
                    Notifications.success(t("SUCCESS_KEY"), t("SUPPLIER_REMOVED_SUCCESS"));
                }
            })
            .catch((error) => {
            })

    };
    const saveProfilePicture = () => {
        const profileValues = uploadImageForm.getFieldValue('uploadImage');
        setSaveProfileLoader(true);
        form.validateFields()
          .then(() => {
            let payload = {
              "supplierID": supplierDetail?.supplierId,
              "profilePicture": {
                "isInsertUpdate": true,
                "documentPath": profileValues?.fileUrl ? profileValues?.fileUrl : null,
                "documentPathThumb": profileValues?.fileThumbUrl ? profileValues?.fileThumbUrl : null,
                "fileName": profileValues?.fileName ? profileValues?.fileName : null,
                "isPathSet": true
              }
    
            }
    
            driverService.driverProfilePicUpload(payload)
              .then((response) => {
                setSaveProfileLoader(false);
                supplierDetail();
                Notification.success(
                 t("PROFILE_PIC_KEY"),
                 t("PROFILE_PIC_UPDATE_SUCCESS")
                );
    
              })
              .catch((error) => {
                setSaveProfileLoader(false);
              });
          })
          .catch((error) => {
            setSaveProfileLoader(false)
          })
      }
    const onProfilePictureUpload = (file, fieldName) => {
        uploadImageForm.setFieldsValue({
            [fieldName]: {
                docType: DocTypes.PROFILE_PIC,
                fileName: file.FileName,
                fileThumbName: file.FileThumbName,
                fileUrl: file.FileURL,
                size: file.size,
                fileThumbUrl: file.FileThumbURL
            }
        });
    };
    const handleUploadProfile = () => {
        setImageUploadLoader(true);
        const uploadedFile = uploadImageForm.getFieldValue("uploadImage");
        if (!uploadedFile || !uploadedFile.fileUrl) {
          uploadImageForm.setFields([
            {
              name: "uploadImage",
              errors: [t("UPLOAD_PROFILE_PIC_MSG")],
            },
          ]);
    
          setImageUploadLoader(false);
          return;
        }
        setTimeout(() => {
          saveProfilePicture()
          console.log(uploadImageForm.getFieldsValue(), "uploadimg payload")
          setImageUploadLoader(false);
          setIsUploadImage(false);
        }, 2000);
      };
    const handleFormChange = (fieldName, val) => {
        editSupplierForm.setFieldValue(fieldName, val);
        setFormValues((prev) => ({
            ...prev,
            [fieldName]: val,
        }));
        if (fieldName == "countryCode") {
            setMinMaxMobileNoLength(getMinAndMaxLengthForMobileNumber(val))
        }

        editSupplierForm.validateFields([fieldName]);

    }
    const onFileUploadDocs = (file, fieldName) => {
        var updatedInquiryDocs = { ...frontDocs };
        updatedInquiryDocs = {
            docType: file.DocType,
            fileName: file.FileName,
            fileThumbName: file.FileThumbName,
            isInsertUpdate: true,
            fileUrl: file.FileURL,
            size: file.size,
            fileThumbUrl: file.FileThumbURL,
            fileData: file.fileData,
        };

        setFrontDocs(updatedInquiryDocs);
        editSupplierForm.setFieldsValue({
            [fieldName]: {
                docType: file.DocType,
                fileName: file.FileName,
                fileThumbName: file.FileThumbName,
                isInsertUpdate: true,
                fileUrl: file.FileURL,
                isPathSet: true,
                fileThumbUrl: file.FileThumbURL
            }
        });
    };
    const disablePastDates = (current) => {
        return current && current <= dayjs().startOf('day');
    };
    // const handleIbanNumberChange = (val, index) => {
    //     // Update the IBAN array
    //     let updatedIbans = [...ibanNumber];
    //     updatedIbans[index] = val;
    //     setIbanNumber(updatedIbans);
    //     const vatNumber = editSupplierForm.getFieldValue("vatNumber");
    //     // Validate IBANs
    //     const errors = updatedIbans.map((iban, idx) => {
    //         let fieldErrors = [];
    //         // Validation 1: IBAN must not match the VAT number
    //         if (iban === vatNumber) {
    //             fieldErrors.push({t("UNIQUE_VAT_AND_IBAN_VALIDATION")});
    //         }
    //         // Validation 2: IBAN numbers must be unique
    //         if (updatedIbans.filter((item) => item === iban).length > 1) {
    //             fieldErrors.push({t("UNIQUE_IBAN_VALIDATION")});
    //         }
    //         return fieldErrors.length ? { name: `vatRegistration_${idx}`, errors: fieldErrors } : null;
    //     }).filter(Boolean); // Remove null values
    //     editSupplierForm.setFields(errors);
    //     // Update the value if no errors for the current field
    //     if (!errors.find((error) => error.name === `vatRegistration_${index}`)) {
    //         editSupplierForm.setFieldsValue({ "iBanNo": updatedIbans });
    //     }
    // };

    const handleIbanNumberChange = (val, index) => {
        // Update the IBAN array
        let updatedIbans = [...ibanNumber];
        updatedIbans[index] = val;
        setIbanNumber(updatedIbans);
        const vatNumber = editSupplierForm.getFieldValue("vatNumber");
        // Validate IBANs
        const errors = updatedIbans.map((iban, idx) => {
            let fieldErrors = [];
            // Validation 1: IBAN must not match the VAT number
            if (iban === vatNumber) {
                fieldErrors.push(t("UNIQUE_VAT_AND_IBAN_VALIDATION"));
            }
            // Validation 2: IBAN numbers must be unique
            if (updatedIbans.filter((item) => item === iban).length > 1) {
                fieldErrors.push(t("UNIQUE_IBAN_VALIDATION"));
            }
            return fieldErrors.length ? { name: `iBanNo_${idx}`, errors: fieldErrors } : null;
        }).filter(Boolean); // Remove null values
        editSupplierForm.setFields(errors);
        // Update the value if no errors for the current field
        if (!errors.find((error) => error.name === `iBanNo_${index}`)) {
            editSupplierForm.setFieldsValue({ [`iBanNo_${index}`]: val });
        }
    };
    const addIbanNumber = () => {
        let temp = [...ibanNumber];
        temp.push("");
        setIbanNumber(temp);
    }
    const handleVisa = (val, index) => {

        const tempList = [...visa];
        tempList[index] = {
            ...tempList[index],
            frontDoc: {
                ...tempList[index].frontDoc,
                fileName: val.FileName || tempList[index].frontDoc.fileName,
                documentPath: val.FileURL || tempList[index].frontDoc.documentPath,
                documentPathThumb:
                    val.FileThumbURL || tempList[index].frontDoc.documentPathThumb,
                isInsertUpdate: true,
                isPathSet: true
            },
            documentNumber: val.documentNumber!==undefined ? val.documentNumber : tempList[index]?.documentNumber,
            issuingCountry: val.issuingCountry || tempList[index]?.issuingCountry,
            expiryDate: val?.expiryDate
                ? moment(val?.expiryDate, format).format("YYYY-MM-DD")
                : null || tempList[index]?.expiryDate,
        };

        setVisa(tempList);
        handleFormChange("visa", tempList);
    };

    const addVisa = () => {
        setVisa([
            ...visa,
            {
                associateId: "",
                documentNumber: "",
                expiryDate: "",
                issuingCountry: "",
                frontDoc: {
                    documentPath: "",
                    documentPathThumb: "",
                    fileName: "",
                },
                document: [
                    {
                        documentPath: "",
                        documentPathThumb: "",
                        fileName: "",
                    },
                ],
            },
        ]);
    };
    const createPayload = () => {
        setBtnLoader(true)
        editSupplierForm.validateFields()
            .then(() => {
                let payload;
                const values = editSupplierForm.getFieldsValue();

                if (checkIsFleetOwner(detailData?.userRole) || checkIsFleetOwnerConverted(detailData?.userRole)) {
                    if (checkIsTurkeyKazak(detailData?.operatingCountry) ) {
                        if (detailData?.operatingCountry === "Kazakhstan") {
                            payload = {
                                supplierId: supplierId,
                                tradeLicense: {
                                    documentNumber: values?.tradeDocumentNumber,
                                    expiryDate: values?.tradeExpiry ? moment(values?.tradeExpiry, format).format("YYYY-MM-DD") : null,
                                    frontDoc: {
                                        isInsertUpdate: values?.tradeFont?.isInsertUpdate,
                                        documentPath: values?.tradeFont?.fileUrl,
                                        documentPathThumb: values?.tradeFont?.fileThumbUrl,
                                        fileName: values?.tradeFont?.fileName,
                                        isPathSet: true,

                                    },
                                },
                                certification: values?.certification,
                                iBanNo: ibanNumber,
                                registrationOffice: values?.registrationOffice
                            };
                        }
                        else {
                            payload = {
                                supplierId: supplierId,
                                vatCertificate: {
                                    documentNumber: values?.vatNumber,
                                    expiryDate: values?.vatExpiry ? moment(values?.vatExpiry, format).format("YYYY-MM-DD") : null,
                                    frontDoc: {
                                        isInsertUpdate: values?.vatUpload?.isInsertUpdate,
                                        documentPath: values?.vatUpload?.fileUrl,
                                        documentPathThumb: values?.vatUpload?.fileThumbUrl,
                                        fileName: values?.vatUpload?.fileName,
                                        isPathSet: true,
                                    },
                                },
                                certification: values?.certification,
                                iBanNo: ibanNumber,
                                registrationOffice: values?.registrationOffice
                            };
                        }
                    }
                    else {
                        payload = {
                            supplierId: supplierId ? supplierId : '',
                            vatCertificate: {
                                documentNumber: values?.vatNumber,
                                expiryDate: values?.vatExpiry ? moment(values?.vatExpiry, format).format("YYYY-MM-DD") : null,
                                frontDoc: {
                                    isInsertUpdate: values?.vatUpload?.isInsertUpdate,
                                    documentPath: values?.vatUpload?.fileUrl,
                                    documentPathThumb: values?.vatUpload?.fileThumbUrl,
                                    fileName: values?.vatUpload?.fileName,
                                    isPathSet: true,
                                },
                            },
                            tradeLicense: {
                                documentNumber: values?.tradeDocumentNumber,
                                expiryDate: values?.tradeExpiry ? moment(values?.tradeExpiry, format).format("YYYY-MM-DD") : null,
                                frontDoc: {
                                    isInsertUpdate: values?.tradeFont?.isInsertUpdate,
                                    documentPath: values?.tradeFont?.fileUrl,
                                    documentPathThumb: values?.tradeFont?.fileThumbUrl,
                                    fileName: values?.tradeFont?.fileName,
                                    isPathSet: true,

                                },
                            },
                        };
                    }
                } else {
                     const hasAnyFilledFields = (visaObj) => {
            return (
              (visaObj?.documentNumber && visaObj.documentNumber.trim() !== '') ||
              (visaObj?.issuingCountry && visaObj.issuingCountry.trim() !== '') ||
              (visaObj?.expiryDate && visaObj.expiryDate.trim() !== '') ||
              (visaObj?.frontDoc?.fileName && visaObj.frontDoc.fileName.trim() !== '') ||
              (visaObj?.frontDoc?.documentPath && visaObj.frontDoc.documentPath.trim() !== '')
            );
          };
                    let formattedVisa = visa?.map((val) => ({
                        ...val,
                         documentNumber:val?.documentNumber ? val?.documentNumber : null,
                        frontDoc:{
                        ...val?.frontDoc,
                       isInsertUpdate:val?.frontDoc?.fileName ? val?.frontDoc?.isInsertUpdate : false,
                        },
                        expiryDate: val?.expiryDate ? moment(val?.expiryDate, format, true).isValid()
                            ? moment(val?.expiryDate, format).format('YYYY-MM-DD')
                            : moment(val?.expiryDate).format('YYYY-MM-DD')
                            : null,
                    })).filter(hasAnyFilledFields)  || [];

                    payload = {
                        supplierId: supplierId ? supplierId : '',
                        driverLicense: {
                            documentNumber: values.drivingLicenseNumber,
                            expiryDate: moment(values.licenseExpiry, format).format("YYYY-MM-DD"),
                            frontDoc: {
                                isInsertUpdate: values?.licenceFront?.isInsertUpdate,
                                isPathSet: true,
                                documentPath: values.licenceFront?.FileURL,
                                documentPathThumb: values.licenceFront?.FileThumbURL,
                                fileName: values?.licenceFront?.FileName,
                            },
                            backDoc: {
                                isInsertUpdate: values?.licenceBack?.isInsertUpdate,
                                isPathSet: true,
                                documentPath: values.licenceBack?.FileURL,
                                documentPathThumb: values.licenceBack?.FileThumbURL,
                                fileName: values?.licenceBack?.FileName,
                            },
                        },
                        nationalID: {
                            documentNumber: values.nationalId,
                            expiryDate: moment(values.nationalIdExpiry, format).format('YYYY-MM-DD'),
                            frontDoc: {
                                isInsertUpdate: values?.nationalIdFront?.isInsertUpdate,
                                isPathSet: true,
                                documentPath: values.nationalIdFront?.FileURL,
                                documentPathThumb: values.nationalIdFront?.FileThumbURL,
                                fileName: values?.nationalIdFront?.FileName,
                            },
                            backDoc: {
                                isInsertUpdate: values?.nationalIdBack?.isInsertUpdate,
                                isPathSet: true,
                                documentPath: values.nationalIdBack?.FileURL,
                                documentPathThumb: values?.nationalIdBack?.FileThumbURL,
                                fileName: values?.nationalIdBack?.FileName,
                            },
                        },
                    };

                    if ( detailData?.serviceTypes?.includes("Domestic")|| detailData?.serviceTypes?.length===0 ) {
                    } else {
                        payload = {
                            ...payload,
                            passport: {
                                documentNumber: values.passportNumber ? values.passportNumber : "",
                                expiryDate: moment(values.passportExpiry, format).format('YYYY-MM-DD') ? moment(values.passportExpiry, format).format('YYYY-MM-DD') : "",
                                frontDoc: {
                                    isInsertUpdate: values?.passportFront?.isInsertUpdate,
                                    isPathSet: true,
                                    documentPath: values.passportFront?.FileURL ? values.passportFront?.FileURL : "",
                                    documentPathThumb: values.passportFront?.FileThumbURL ? values.passportFront?.FileThumbURL : "",
                                    fileName: values.passportFront?.FileName ? values.passportFront?.FileName : "",
                                },
                                backDoc: {
                                    isInsertUpdate: values?.passportBack?.isInsertUpdate,
                                    isPathSet: true,
                                    documentPath: values.passportBack?.FileURL ? values.passportBack?.FileURL : "",
                                    documentPathThumb: values.passportBack?.FileThumbURL ? values.passportBack?.FileThumbURL : "",
                                    fileName: values.passportBack?.FileName ? values.passportBack?.FileName : "",
                                },
                            },
                            visa: formattedVisa,
                        };
                    }
                }
                debugger;
                supplierService
                    .addSupplierKyc(payload)
                    .then((response) => {
                        if (response?.status === 200) {
                            setBtnLoader(false)
                            setIsEditModalOpen(false)
                            supplierDetail();
                            Notification.success(t("KYC_DETAIL_KEY"), t("KYC_DETAILS_SUCCESS"));

                        }
                    }).catch((error) => {
                        setBtnLoader(false);
                        console.error("supplierService addSupplierKyc error", error);
                        Notification.error(
                        t("KYC_DETAIL_KEY"),
                        error?.response?.data?.message || t("KYC_DETAILS_FAILED")
                        );
                        return null;
                    });

                console.log(payload, "payload from the function");
                return payload; // Return payload directly without using a promise
            })
            .catch((error) => {
                setBtnLoader(false);
                console.error("Validation failed:", error); // Log detailed validation errors
                // You can even log specific fields from the error
                let errorMessage =
                error?.response?.data?.message ||
                error?.message ||
                t("SOMETHING_WENT_WRONG");
                Notification.error(t("KYC_DETAIL_KEY"), errorMessage);
                return null;
            })
            
    };

    const handleEditSupplier = () => {
        createPayload()
    }

    const verifyNowHandler = async() => {
        let token = "";
        try {
        token = await executeRecaptcha("otp_request_action");
        console.log("RECAPTCHA TOKEN:", token);
        } catch (recaptchaError) {
        console.error("reCAPTCHA failed:", recaptchaError);
        Notification.error("reCAPTCHA verification failed. Please try again.");
                setIsOtpRequested(false);
                setIsDisableOtpAction(false);
        return;
        }
        console.log("RECAPTCHA TOKEN: ", token);

        const payload = {
            countryCode: detailData?.countryCode,
            mobileNo: detailData?.mobileNo,
            otpType: 'OtpSend',
            languageISOCode: language,
            captchaToken: token, 
        };
        form.setFieldValue("countryCode", detailData?.countryCode)
        form.setFieldValue("mobileNumber", detailData?.mobileNo)
        form.setFieldValue("otpNumber", "");
        setVerifyModal(true);
        setIsDisableOtpAction(true);
        otpService.sendOTP(payload)
            .then((response) => {
                if (response.status === 200) {
                    setOtpDetails(response?.data);
                    localStorageService.setKey(LocalStorageKeys.UniqueId, response?.data?.data);
                    Notification.success(t("SUCCESS_KEY"), `${t("OTP_SENT_TO_SUCCESS")} ${detailData?.mobileNo}`);
                    setIsOtpRequested(true);
                    setIsDisableOtpAction(false);
                    setTimer(120);
                }
            })
            .catch((error) => {
                setIsOtpRequested(false);
                setIsDisableOtpAction(false);
            })
    }

    const onResendOTP = async () => {
        const uniqueId = otpDetails?.data

        if (timer === 0) {
            //  Recaptcha Token for resend
            let token = "";
            try {
            token = await executeRecaptcha("otp_request_action"); 
            console.log("RECAPTCHA TOKEN:", token);
            } catch (recaptchaError) {
            console.error("reCAPTCHA failed:", recaptchaError);
            Notification.error("reCAPTCHA verification failed. Please try again.");
            setIsDisableOtpAction(false)
            return;
            }

            const payload = {
                "uniqueId": otpDetails?.data,
                "countryCode": detailData?.countryCode,
                "otpType": "OtpSend",
                "languageISOCode": language,
                "captchaToken": token
            }
            setIsDisableOtpAction(true)
            otpService.resendOTP(payload)
                .then((response) => {
                    if (response?.status === 200) {
                        setTimer(120);
                        setIsDisableOtpAction(false)
                        setIsOtpRequested(true);
                        setOtpDetails(response?.data);
                        localStorageService.setKey(LocalStorageKeys.UniqueId, uniqueId);
                        Notification.success(t("SUCCESS_KEY"), `${t("OTP_SENT_TO_SUCCESS")} ${detailData?.mobileNo}`);
                    }
                })
                .catch((error) => {
                    setIsDisableOtpAction(false)

                })
        }
    }

    const verifyOTPHandler = () => {

        const payload = {
            otpDetails: {
                otpNumber: form.getFieldValue('otpNumber'),
                uniqueId: otpDetails?.data,
            },
            userId: detailData?.userId,
            userRole: OwnerType.FLEET_OWNER
        }
        setBtnLoader(true);
        driverService.verifyDriverMobile(payload)
            .then((response) => {
                if (response.status === 200) {
                    Notification.success(t("SUCCESS_KEY"), t("OTP_VERIFIED_SUCCESS"));
                    setVerifyModal(false)
                    setBtnLoader(false);
                    let localSupplierDetail={...detailData};
                    localSupplierDetail.isMobileNumberVerified=true;
                    setdetailData(localSupplierDetail);
                }
            })
            .catch((error) => {
                setBtnLoader(false);
            })
    }

    const getApprovalPendingfn = (buttonFlag) =>{
        setbuttonNameChange(buttonFlag)

    }

// check uniquness
     const uniqueDocNumberRule = (fieldName) => ({
  validator: (_, value) => {
    const val = value?.toString().trim();
    if (!val) return Promise.resolve();
     if (
      (removeUniquenessCheckForCountry(detailData?.country)) &&
      (fieldName === "drivingLicenseNumber" || fieldName === "nationalId")
    ) {
      return Promise.resolve();
    }
    const {vatNumber,tradeDocumentNumber, drivingLicenseNumber, passportNumber, nationalId, visa = [] } =
      editSupplierForm.getFieldsValue();

    const allValues = [vatNumber,tradeDocumentNumber,drivingLicenseNumber, passportNumber,nationalId,
      ...visa?.map((v) => v?.documentNumber),
    ].filter(Boolean);
    const duplicates = allValues.filter((v) => v?.toString().trim() === val);
    return duplicates.length > 1
      ? Promise.reject(new Error(`Field must be unique`))
      : Promise.resolve();
  },
});

  // ****************** OCR EDIT  *****************
    const OCRFieldNames = {
        VAT_CERTIFICATE: "VAT_CERTIFICATE",
        TRADE_LICENSE: "TRADE_LICENSE",
        DRIVING_LICENSE: "DRIVING_LICENSE",
        PASSPORT: "PASSPORT",
        NATIONAL_ID: "NATIONAL_ID",
        VISA: "VISA",
    };

    const ocrFieldToStateKey = {
        [OCRFieldNames.VAT_CERTIFICATE]: "vatCertificate",
        [OCRFieldNames.TRADE_LICENSE]: "tradeLicense",
        [OCRFieldNames.DRIVING_LICENSE]: "drivingLicense",
        [OCRFieldNames.PASSPORT]: "passport",
        [OCRFieldNames.NATIONAL_ID]: "nationalID",
        [OCRFieldNames.VISA]: "visa",
    };

    const config = {
        onUploadProgress: function (progressEvent) {
        console.log("progressEvent.total", progressEvent.total);
        console.log("progressEvent.loaded", progressEvent.loaded);
        const percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
        );
        console.log("percentCompleted", percentCompleted);

        setUploadState((prev) => {
        let status = "";
        let description = "";

        if (!prev.started) {
            status = "Hold Tight - File is Being Prepared Securely.";
            description = "Please don’t close or refresh the screen.";
            if (percentCompleted === 100) {
            status = "Final Step - Converting Your Content.";
            description = "Hang on, we’re wrapping up things.";
            }
        } else if (percentCompleted < 30) {
            status = "Hold Tight - File is Being Prepared Securely.";
            description = "Please don’t close or refresh the screen.";
        } else if (percentCompleted < 70) {
            status = "Almost There - Preparing Your Documents.";
            description = "Making sure everything is in right place.";
        } else if (percentCompleted < 100) {
            status = "Final Step - Converting Your Content.";
            description = "Hang on, we’re wrapping up things.";
        } else {
            status = "Final Step - Converting Your Content.";
            description = "Hang on, we’re wrapping up things.";
        }

        return {
            progress: percentCompleted,
            status,
            description,
            started: true,
        };
        });
        },
    };

  //******* */ upload directly to CLOUD *********
  const uploadDirectToCloud = async (
    fileWrapper,
    fieldName,
    ocrFieldName,
    fileType,
    index
  ) => {
    const actualFile = fileWrapper.file ?? fileWrapper;

    const form = new FormData();
    form.append("file", actualFile);

    const payload = {
      docType: fileType,
      entityType: EntityTypes.SUPPLIER,
      fileName: actualFile.name,
      docName: actualFile.name ? actualFile.name.replace(/\s+/g, "_") : "",
      fileData: "",
      fileURL: "",
      fileThumbURL: "",
      fileThumbName: "",
      uniqueID: "",
      totalPartition: 1,
      seq: 1,
      isPathSet: true,
    };

    form.append("details", JSON.stringify(payload));

    try {
      const response = await documentService.uploadDocumentV2(form, config);
      if (response.data.status === 200) {
        const data = response.data.data;
        console.log("uploadDocumentV2 data", data);

        // // call same flow as onFileUploadDocs
        // editSupplierForm.setFieldsValue({
        //   [fieldName]: {
        //     docType: data.docType,
        //     fileName: data.fileName,
        //     fileThumbName: data.fileThumbName,
        //     isInsertUpdate: true,
        //     fileUrl: data.fileURL,
        //     isPathSet: true,
        //     fileThumbUrl: data.fileThumbURL,
        //   },
        // });

        const stateKey = ocrFieldToStateKey[ocrFieldName];
        console.log("stateKey", stateKey);

        // setEditSupplierDocs((prev) => ({
        //   ...prev,
        //   [stateKey]: {
        //     ...prev?.[stateKey],
        //     frontDoc: {
        //       ...prev?.[stateKey]?.frontDoc,
        //       documentPath: data.fileURL || null,
        //       documentPathThumb: data.fileThumbURL || null,
        //       fileName: data.fileName || null,
        //     },
        //   },
        // }));

        // decide whether it's a backDoc upload
        // VISA NOT HAANDLED HERE
        // const isBackDoc =
        //   fieldName?.toLowerCase().includes("back") &&
        //   (ocrFieldName === OCRFieldNames.DRIVING_LICENSE ||
        //     ocrFieldName === OCRFieldNames.NATIONAL_ID ||
        //     ocrFieldName === OCRFieldNames.PASSPORT);

        // setEditSupplierDocs((prev) => ({
        //   ...prev,
        //   [stateKey]: {
        //     ...prev?.[stateKey],
        //     ...(isBackDoc
        //       ? {
        //           backDoc: {
        //             ...prev?.[stateKey]?.backDoc,
        //             documentPath: data.fileURL || null,
        //             documentPathThumb: data.fileThumbURL || null,
        //             fileName: data.fileName || null,
        //           },
        //         }
        //       : {
        //           frontDoc: {
        //             ...prev?.[stateKey]?.frontDoc,
        //             documentPath: data.fileURL || null,
        //             documentPathThumb: data.fileThumbURL || null,
        //             fileName: data.fileName || null,
        //           },
        //         }),
        //   },
        // }));

        // const normalizedFile = {
        //   DocType: data.docType,
        //   EntityId: data.entityId,
        //   FileName: data.fileName,
        //   FileThumbName: data.fileThumbName,
        //   FileThumbURL: data.fileThumbURL,
        //   FileURL: data.fileURL,
        //   Status: data.status ?? false,
        // };

        // console.log("normalizedFile", normalizedFile);

        // onFileUploadDocs(normalizedFile, fieldName);

        // VISA HANDLED HERE
        if (ocrFieldName === OCRFieldNames.VISA && index !== null) {
          let localVisa = [...visa];
          localVisa[index].frontDoc = {
            ...localVisa[index].frontDoc,
            fileName: data.fileName || "",
            documentPath: data.fileURL || "",
            documentPathThumb: data.fileThumbURL || "",
            isInsertUpdate: true,
            isOCRDoc: false,
          };

          setVisa(localVisa);
          handleFormChange("visa", localVisa);
        } else {
          const isBackDoc =
            fieldName?.toLowerCase().includes("back") &&
            (ocrFieldName === OCRFieldNames.DRIVING_LICENSE ||
              ocrFieldName === OCRFieldNames.NATIONAL_ID ||
              ocrFieldName === OCRFieldNames.PASSPORT);

          setEditSupplierDocs((prev) => ({
            ...prev,
            [stateKey]: {
              ...prev?.[stateKey],
              ...(isBackDoc
                ? {
                    backDoc: {
                      ...prev?.[stateKey]?.backDoc,
                      documentPath: data.fileURL || null,
                      documentPathThumb: data.fileThumbURL || null,
                      fileName: data.fileName || null,
                    },
                  }
                : {
                    frontDoc: {
                      ...prev?.[stateKey]?.frontDoc,
                      documentPath: data.fileURL || null,
                      documentPathThumb: data.fileThumbURL || null,
                      fileName: data.fileName || null,
                    },
                  }),
            },
          }));

          const normalizedFile = {
            DocType: data.docType,
            EntityId: data.entityId,
            FileName: data.fileName,
            FileThumbName: data.fileThumbName,
            FileThumbURL: data.fileThumbURL,
            FileURL: data.fileURL,
            Status: data.status ?? false,
          };

          console.log("normalizedFile", normalizedFile);

          onFileUploadDocs(normalizedFile, fieldName);
        }

        Notification.success(t("SUCCESS_KEY"), t("FILE_UPLOADED_SUCCESS"));
      } else {
        Notification.error(response.data.message || "Upload failed");
      }
    } catch (error) {
      console.error("uploadDirectToJCloud error", error);
      Notification.error(t("ERROR_MESSAGE"));
    }
  };

  const ocrMappedData = (ocrFieldName, doc, index) => {
    console.log("ocrMappedData doc", doc);
    console.log("ocrMappedData ocrFieldName", doc);
    switch (ocrFieldName) {
      case "VAT_CERTIFICATE": {
        const { docNumber, docExpiryDate, frontUrl } = doc;
        const parsedVatExpiry = docExpiryDate
          ? dayjs(docExpiryDate, "DD-MM-YYYY").format("DD-MM-YYYY")
          : null;

        const vatUpload = {
          // DocType: doc.docType || "VATCERTFD",
          // EntityId: EntityTypes.SUPPLIER,
          // FileName: `ActualSupplier/${ocrLogId}_VATCERTFD${documentUtility.getFileExtension(frontUrl)}`,
          // FileThumbName: `ActualSupplier_Thumb/${ocrLogId}_VATCERTFD${documentUtility.getFileExtension(frontUrl)}`,
          // FileThumbURL: documentUtility.getThumbnailImagePath(frontUrl) || null,
          // FileURL: frontUrl || null,
          // Status: false,
          docType: doc.docType || "VATCERTFD",
          fileName: `ActualSupplier/${ocrLogId}_VATCERTFD${documentUtility.getFileExtension(
            frontUrl
          )}`,
          fileThumbName: `ActualSupplier_Thumb/${ocrLogId}_VATCERTFD${documentUtility.getFileExtension(
            frontUrl
          )}`,
          fileUrl: frontUrl || null,
          fileThumbUrl: documentUtility.getThumbnailImagePath(frontUrl) || null,
          isPathSet: true,
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        setEditSupplierDocs((prev) => ({
          ...prev,
          vatCertificate: {
            ...prev?.vatCertificate,
            frontDoc: {
              ...prev?.frontDoc,
              documentPath: vatUpload.fileUrl || null,
              documentPathThumb: vatUpload.fileThumbUrl || null,
              fileName: vatUpload.fileName || null,
            },
          },
        }));

        editSupplierForm.setFieldsValue({
          vatNumber: docNumber || undefined,
          vatExpiry: parsedVatExpiry,
          vatUpload,
        });
        break;
      }

      case "TRADE_LICENSE": {
        const { docNumber, docExpiryDate, frontUrl } = doc;
        const parsedTradeExpiry = docExpiryDate
          ? dayjs(docExpiryDate, "DD-MM-YYYY").format("DD-MM-YYYY")
          : null;

        const licenceUpload = {
          // DocType: doc.docType || "TRADELICFD",
          // EntityId: EntityTypes.SUPPLIER,
          // FileName: `ActualSupplier/${ocrLogId}_TRADELICFD${documentUtility.getFileExtension(frontUrl)}`,
          // FileThumbName: `ActualSupplier_Thumb/${ocrLogId}_TRADELICFD${documentUtility.getFileExtension(frontUrl)}`,
          // FileThumbURL: documentUtility.getThumbnailImagePath(frontUrl) || null,
          // FileURL: frontUrl || null,
          // Status: false,
          docType: doc.docType || "TRADELICFD",
          fileName: `ActualSupplier/${ocrLogId}_TRADELICFD${documentUtility.getFileExtension(
            frontUrl
          )}`,
          fileThumbName: `ActualSupplier_Thumb/${ocrLogId}_TRADELICFD${documentUtility.getFileExtension(
            frontUrl
          )}`,
          fileUrl: frontUrl || null,
          fileThumbUrl: documentUtility.getThumbnailImagePath(frontUrl) || null,
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        setEditSupplierDocs((prev) => ({
          ...prev,
          tradeLicense: {
            ...prev?.tradeLicense,
            frontDoc: {
              ...prev?.frontDoc,
              documentPath: licenceUpload?.fileUrl || null,
              documentPathThumb: licenceUpload?.fileThumbUrl || null,
              fileName: licenceUpload?.fileName || null,
            },
          },
        }));

        editSupplierForm.setFieldsValue({
          tradeDocumentNumber: docNumber || undefined,
          tradeExpiry: parsedTradeExpiry,
          tradeFont: licenceUpload,
        });
        break;
      }

      case "DRIVING_LICENSE": {
        const { docNumber, docExpiryDate, frontUrl, backUrl } = doc;
        const parsedTradeExpiry = docExpiryDate
          ? dayjs(docExpiryDate, "DD-MM-YYYY").format("DD-MM-YYYY")
          : null;

        const frontDoc = {
          docType: "DRLFD",
          fileName:
            `ActualDriver/${ocrLogId}_DRLFD${documentUtility.getFileExtension(
              frontUrl
            )}` || null,
          fileThumbName:
            `ActualDriver_Thumb/${ocrLogId}_DRLFD${documentUtility.getFileExtension(
              frontUrl
            )}` || null,
          fileThumbUrl: documentUtility.getThumbnailImagePath(frontUrl) || null,
          fileUrl: frontUrl || null,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        const backDoc = {
          docType: "DRLBD",
          fileName:
            `ActualDriver/${ocrLogId}_DRLFD${documentUtility.getFileExtension(
              backUrl
            )}` || null,
          fileThumbName:
            `ActualDriver_Thumb/${ocrLogId}_DRLFD${documentUtility.getFileExtension(
              backUrl
            )}` || null,
          fileThumbUrl: backUrl || null,
          fileUrl: backUrl || null,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        setEditSupplierDocs((prev) => ({
          ...prev,
          drivingLicense: {
            ...prev?.drivingLicense,
            frontDoc: {
              ...prev?.frontDoc,
              documentPath: frontDoc?.fileUrl || null,
              documentPathThumb: frontDoc?.fileThumbUrl || null,
              fileName: frontDoc?.fileName || null,
            },
            backDoc: {
              ...prev?.backDoc,
              documentPath: backDoc?.fileUrl || null,
              documentPathThumb: backDoc?.fileThumbUrl || null,
              fileName: backDoc?.fileName || null,
            },
          },
        }));

        editSupplierForm.setFieldsValue({
          drivingLicenseNumber: docNumber || undefined,
          licenseExpiry: parsedTradeExpiry,
          licenceFront: frontDoc,
          licenceBack: backDoc,
        });
        break;
      }

      case "NATIONAL_ID": {
        const { docNumber, docExpiryDate, frontUrl, backUrl } = doc;
        const parsedTradeExpiry = docExpiryDate
          ? dayjs(docExpiryDate, "DD-MM-YYYY").format("DD-MM-YYYY")
          : null;

        const frontDoc = {
          docType: "NIDFD",
          fileName:
            `ActualDriver/${ocrLogId}_NIDFD${documentUtility.getFileExtension(
              frontUrl
            )}` || null,
          fileThumbName:
            `ActualDriver_Thumb/${ocrLogId}_NIDFD${documentUtility.getFileExtension(
              frontUrl
            )}` || null,
          fileThumbUrl: documentUtility.getThumbnailImagePath(frontUrl) || null,
          fileUrl: frontUrl || null,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        const backDoc = {
          docType: "NIDBD",
          fileName:
            `ActualDriver/${ocrLogId}_NIDBD${documentUtility.getFileExtension(
              backUrl
            )}` || null,
          fileThumbName:
            `ActualDriver_Thumb/${ocrLogId}_NIDBD${documentUtility.getFileExtension(
              backUrl
            )}` || null,
          fileThumbUrl: backUrl || null,
          fileUrl: backUrl || null,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        setEditSupplierDocs((prev) => ({
          ...prev,
          nationalID: {
            ...prev?.nationalID,
            frontDoc: {
              ...prev?.frontDoc,
              documentPath: frontDoc?.fileUrl || null,
              documentPathThumb: frontDoc?.fileThumbUrl || null,
              fileName: frontDoc?.fileName || null,
            },
            backDoc: {
              ...prev?.backDoc,
              documentPath: backDoc?.fileUrl || null,
              documentPathThumb: backDoc?.fileThumbUrl || null,
              fileName: backDoc?.fileName || null,
            },
          },
        }));

        editSupplierForm.setFieldsValue({
          nationalId: docNumber || undefined,
          nationalIdExpiry: parsedTradeExpiry,
          nationalIdFront: frontDoc,
          nationalIdBack: backDoc,
        });
        break;
      }

      case "PASSPORT": {
        const { docNumber, docExpiryDate, frontUrl, backUrl } = doc;
        const parsedTradeExpiry = docExpiryDate
          ? dayjs(docExpiryDate, "DD-MM-YYYY").format("DD-MM-YYYY")
          : null;

        const frontDoc = {
          docType: "PASSFD",
          fileName:
            `ActualDriver/${ocrLogId}_PASSFD${documentUtility.getFileExtension(
              frontUrl
            )}` || null,
          fileThumbName:
            `ActualDriver_Thumb/${ocrLogId}_PASSFD${documentUtility.getFileExtension(
              frontUrl
            )}` || null,
          fileThumbUrl: documentUtility.getThumbnailImagePath(frontUrl) || null,
          fileUrl: frontUrl || null,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        const backDoc = {
          docType: "PASSBD",
          fileName:
            `ActualDriver/${ocrLogId}_PASSBD${documentUtility.getFileExtension(
              backUrl
            )}` || null,
          fileThumbName:
            `ActualDriver_Thumb/${ocrLogId}_PASSBD${documentUtility.getFileExtension(
              backUrl
            )}` || null,
          fileThumbUrl: backUrl || null,
          fileUrl: backUrl || null,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        setEditSupplierDocs((prev) => ({
          ...prev,
          passport: {
            ...prev?.drivingLicense,
            frontDoc: {
              ...prev?.frontDoc,
              documentPath: frontDoc?.fileUrl || null,
              documentPathThumb: frontDoc?.fileThumbUrl || null,
              fileName: frontDoc?.fileName || null,
            },
            backDoc: {
              ...prev?.backDoc,
              documentPath: backDoc?.fileUrl || null,
              documentPathThumb: backDoc?.fileThumbUrl || null,
              fileName: backDoc?.fileName || null,
            },
          },
        }));

        editSupplierForm.setFieldsValue({
          passportNumber: docNumber || undefined,
          passportExpiry: parsedTradeExpiry,
          passportFront: frontDoc,
          passportBack: backDoc,
        });
        break;
      }

      case "VISA": {
        const { docNumber, docExpiryDate, frontUrl, issueCountry } = doc;
        const parsedVisaExpiry = docExpiryDate
          ? dayjs(docExpiryDate, "DD-MM-YYYY").isValid()
            ? dayjs(docExpiryDate, "DD-MM-YYYY").format("YYYY-MM-DD")
            : docExpiryDate
          : "";

        const visaFront = {
          fileName:
            `ActualDriver/${ocrLogId}_VISA${documentUtility.getFileExtension(
              frontUrl
            )}` || null,
          documentPath: frontUrl || null,
          documentPathThumb:
            documentUtility.getThumbnailImagePath(frontUrl) || null,
          isInsertUpdate: false,
          isOCRDoc: true,
          isPathSet: true,
        };

        if (index !== null && index !== undefined) {
          let localVisa = [...visa];
          localVisa[index] = {
            ...localVisa[index],
            documentNumber: docNumber || "",
            issuingCountry: issueCountry || "",
            expiryDate: parsedVisaExpiry,
            frontDoc: {
              ...localVisa[index].frontDoc,
              visaFront,
            },
          };

          setVisa(localVisa);
          handleFormChange("visa", localVisa);
        }

        break;
      }

      default: {
        console.warn(
          `No mapping found in ocrMappedData for docType: ${ocrFieldName}`,
          doc
        );

        break;
      }
    }
  };

  const uploadToOCR = async (ocrConfirmedFiles) => {
    if (!ocrConfirmedFiles || ocrConfirmedFiles.length === 0) return;

    const parserAppMap = {
      // truck: process.env.REACT_APP_OCR_ASSET,
      // fleet: process.env.REACT_APP_OCR_SHIPPER_SUPPLIER,
      // driver: process.env.REACT_APP_OCR_DRIVER_STO,
      truck: "RDLj2vIouDleRWu0",
      fleet: "mCFBiv6Hcl8U02Sp",
      // driver: "2p1fqkPj0wFL9T0E",
      driver: "testqkPj0wFL9T0E",
    };
    // const parserApp = parserAppMap["fleet"] || "";
    const parserKey = ownerType === "STO" ? "driver" : "fleet";
    const parserApp = parserAppMap[parserKey] || "";
    console.log("parserApp", parserApp);
    const form = new FormData();
    // form.append("file", uploadedFileData.file);

    ocrConfirmedFiles.forEach((item) => {
      if (item?.file) {
        form.append("files", item.file);
      }
    });
    form.append("parserApp", parserApp);
    // form.append("model", "v1");
    // form.append("extra_accuracy", "false");
    try {
      console.log("Sending to OCR", form.getAll("files"), parserApp);
      const response = await documentService.ocrCustomFileUploadService(
        form,
        config
      );
      const parsedData = response?.data?.data?.parsedData;
    //   const ocrLogId = response?.data?.data?.ocrLogId;
      const newOcrLogId  = response?.data?.data?.ocrLogId;
      if (parsedData && newOcrLogId) {
        console.log("uploadToOCR parsedData", parsedData);
        setOcrParsedData(parsedData);
        // setOcrLogId(ocrLogId);
        setOcrLogId(prev =>
          prev ? `${prev},${newOcrLogId}` : String(newOcrLogId)
        );
        return parsedData;
      } else {
        console.warn("No parsedData in OCR response");
        // setOcrLogId("");
      }
    } catch (error) {
      console.error("OCR Upload Failed:", error);
      const message =
        error?.response?.data?.message ||
        "OCR upload failed due to a server error.";
      Notification.error("Upload Failed", message);
    }
  };

  const handleOCRConformFileChange = async (
    newFiles,
    fieldName,
    ocrFieldName,
    fileType,
    index = null
  ) => {
    if (!newFiles || newFiles.length === 0) return;

    console.log("handleOCRConformFileChange newFiles", newFiles[0]);
    console.log("handleOCRConformFileChange fieldName", fieldName);

    setUploadState(initialUploadState);
    setIsUploadingPopupVisible(true);

    let responseParseData = null;
    try {
      // Calling the OCR API function to fetch OCR data
      responseParseData = await uploadToOCR(newFiles);
    } catch (error) {
      console.error("OCR failed, will fallback to direct upload", error);
    }

    // IF Data is From OCR and Data is Correct as per ocrFieldName
    if (responseParseData?.documents?.length) {
      const documents = responseParseData.documents;
      const matchedDoc = documents.find(
        (doc) => doc.docType === ocrFieldName && doc.status === true
      );

      if (matchedDoc) {
        ocrMappedData(ocrFieldName, matchedDoc, index);
        debugger;
        setIsUploadingPopupVisible(false);
        return;
      }
    }

    //  OCR failed or didn’t match → direct upload to Cloud
    try {
      debugger;
      await uploadDirectToCloud(
        newFiles[0],
        fieldName,
        ocrFieldName,
        fileType,
        index
      );
    } catch (err) {
      console.error("Direct upload failed too:", err);
    } finally {
      setIsUploadingPopupVisible(false); // close popup after cloud upload
    }
  };

  const handleEditClick = () => {
    setEditSupplierDocs(structuredClone(supplierDocs)); // deep clone
    setIsEditModalOpen(true);
  };

  const handleEditingDeleteFile = (fieldName, ocrFieldName) => {
    console.log("handleEditingDeleteFile", fieldName);
    const stateKey = ocrFieldToStateKey[ocrFieldName];

    setEditSupplierDocs((prev) => {
      const updated = { ...prev };

      if (
        ["licenceBack", "nationalIdBack", "passportBack"].includes(fieldName)
      ) {
        // Delete from backDoc
        updated[stateKey] = {
          ...prev?.[stateKey],
          backDoc: {
            documentPath: null,
            documentPathThumb: null,
            fileName: null,
          },
        };
      } else {
        // Delete from frontDoc
        updated[stateKey] = {
          ...prev?.[stateKey],
          frontDoc: {
            documentPath: null,
            documentPathThumb: null,
            fileName: null,
          },
        };
      }

      return updated;
    });
  };

  const handleVisaDeleteFileUpload = (index) => {
    setVisa((prev) => {
      const updatedVisa = [...prev];

      updatedVisa[index].frontDoc = {
        ...updatedVisa[index].frontDoc,
        fileName: "",
        documentPath: "",
        documentPathThumb: "",
        isInsertUpdate: false,
        isOCRDoc: false,
        isPathSet: false,
      };

      return updatedVisa;
    });
  };

    return (
        <>
            {isLoadingSupplierDetail?<Spin style={{ marginLeft: "50%", marginTop: "10%" }}></Spin>:
            <div className='addfleet-detail'>
                <Row gutter={16} className="card-row">
                    <Col span={12} className="flex-column">
                        <Card className="card-truck" title={<div className="card-title">{t("FLEET_TRUCKS_BASIC_INFORMATION")}</div>}
                            extra={
                                <Dropdown menu={{
                                    items: [
                                        {
                                            key: '1',
                                            label: t("REMOVE_FROM_FLEET_KEY"),
                                        },
                                    ],
                                    onClick: handleMenuClick,

                                }}
                                >
                                    <MoreOutlined style={{ fontSize: '19px' }} />
                                </Dropdown>
                            }
                        >
                            {detailData?.status === 'Blocked' &&
                            <div>
                            <span className='block-msg'><img src={ExclamatoryMark}/>Blocked for crossing business limit <a onClick={(()=>setShowDrawer(true))} style={{color:"#FF833C",textDecoration:"underline"}}>{t("PAYBLES_BLOCK_UPDATE_DOCUMENT")}</a></span>
                            </div>
                            }
                            <div>
                                <div className="img-div">
                                    {detailData?.profilePicture ?
                                        <img
                                            src={detailData?.profilePicture?.documentPath}
                                            alt="Profile Picture"
                                            className="profile-image"
                                        /> :
                                        <img src={DriverGruardImg} alt="Truck" />}
                                        {/* uncomment for profile pic upload for supplier (check payload) */}
                                     {/* <button className="save-btn-class" onClick={() => setIsUploadImage(true)} >  */}

                                       {/* {t("ACCOUNT_UPLOAD_IMAGE")}  */}
                                      {/* {detailData?.profilePicture ? <img className="edit-icon" src={EditImg} /> : "📷"} */}

                                    {/* </button> */}
                                </div>
                                <div className='details-rows-driver'>
                                    <Row gutter={[8, 8]} className="data-row">
                                        <Col span={8}>
                                            <span>{t("FLEET_DRIVER_NAME")}</span>
                                            <span>{detailData?.name ? detailData?.name : "NA"}</span>
                                        </Col>
                                        <Col span={8}>
                                            <span>{t("FLEET_DRIVER_MOBILE_NO")}</span>
                                            <span>{"+"}{detailData?.countryCode ? detailData?.countryCode : "NA"}{" "}{detailData?.mobileNo ? detailData?.mobileNo : "NA"}
                                                <span className="verify-now" onClick={verifyNowHandler}>
                                                    {/* <span className="verify-now" > */}

                                                    {detailData?.isMobileNumberVerified ? "" : t("FLEET_VERIFY_NOW_BTN")}
                                                </span>
                                            </span>
                                            {detailData?.isMobileNumberVerified ?
                                                <span style={{ color: "#287D3C" }}><CheckCircleOutlined /> {t("OTP_VERIFIED_COMMON")}</span>
                                                :
                                                <span className="otp-not-verified"><img src={AlertCircle} alt='' />{t("NOT_VERIFIED_KEY")}</span>
                                            }
                                        </Col>
                                        <Col span={8}>
                                            <span>{t("FLEET_DRIVER_STATUS")}</span>
                                            {/* <span className={detailData?.statusText === 'Available' ? t("AVAILABLE_STATUS_KEY") : detailData?.statusText === 'Booked' ? t("BOOKED_STATUS_KEY") : t("warning_status_key")}>
                              {detailData?.statusText ? detailData?.statusText : "NA"}</span> */}
                                            <span className={detailData?.statusText === 'Available' ? t("AVAILABLE_STATUS_KEY") : detailData?.statusText === 'Booked' ? t("BOOKED_STATUS_KEY") : t("WARNING_STATUS_KEY")}>
                                                {detailData?.status}</span>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </Card>
                    </Col>

                 {/* *************RIGHT WRAPPER *************** */}
                    <Col span={12} className="flex-column">
                        <Card className="card-truck" title={<div className='card-title-div'>
                            <div className="card-title">{t("FLEET_TRUCKS_UPLOADED_DOC")} </div>
                            <div className='edit-btn' 
                            // onClick={() => setIsEditModalOpen(true)}
                            onClick={handleEditClick}
                            ><img src={pencilEdit} alt='editIcon' />{t("FLEET_MANAGEMENT_EDIT")}</div>

                        </div>}>
                            <div className='doc-data'>
                                 {detailData?.status === 'Blocked' &&
                                <Card style={{marginBottom:"1rem"}}>
                                <div style={{fontWeight:"bold"}}>
                                {/* You're Temporarily Blocked */}
                                {t("PAYBLES_BLOCK_MSG")}
                                </div>
                                <div>
                                 <Row>  
                                <Col span={20}>    
                                <Paragraph>
                                You are currently blocked due to crossing the business limit. 
                                Please upload required documents to regain access.
                                </Paragraph>
                                <Button 
                                type="primary" 
                                size="large"
                                className="upgrade-button"
                                onClick={(()=>setShowDrawer(true))}
                                // loading={buttonNameChange}
                                >
                                    {detailData?.userKycStatus == 'Approval Pending' ? 'Approval Pending': t("PAYBLES_BLOCK_UPDATES_DETAILS_BTN")}
                                
                                </Button>
                                </Col>
                                {showDrawer && (
                                    <RequestToFleetOwnerC
                                        openAddDetailsDrawer={showDrawer}
                                        getApprovalPendingfn = {getApprovalPendingfn}
                                        onClose={() => setShowDrawer(false)}
                                        supplierDetail={detailData}
                                        supplierDocs={supplierDocs}
                                        supplierDetailfn={supplierDetail}
                                        
                                    />
                                )}

                                <Col span={4}>
                                <img src={WriterBlock} alt=""/>
                                </Col>
                                </Row>
                                </div>
                                </Card>}

                                {checkIsFleetOwner(user?.userRole) || checkIsFleetOwnerConverted(user?.userRole) &&
                                    <div>
                                        <Row gutter={16} className="data-row">
                                            <Col span={9}>
                                                {/* <span className="trucks-span">{item.type}</span> */}
                                                <span>{t("VAT_CERTIFICATE_COMMON")}</span>
                                            </Col>
                                            <Col span={15} className="doc-file">
                                                <Row justify={'end'}>

                                                    <img style={{ height: '5rem', width: '6vw' }} src={supplierDocs ? supplierDocs?.vatCertificate?.frontDoc?.documentPath : ""} alt="alt" />
                                                    <img style={{ height: '5rem' }} src={ExistsImg}></img>
                                                    {/* } */}
                                                </Row>
                                            </Col>
                                        </Row>
                                        <Row gutter={16} className="data-row">
                                            <Col span={10}>
                                                <span>{t("NUMBER_COMMON")}</span>
                                                {/* <span>{item?.documentNumber ? item?.documentNumber : "NA"}</span> */}
                                            </Col>
                                            <Col span={14}>
                                                <span>{t("FLEET_DRIVER_EXPIRY_DATE")}</span>
                                                {/* <span>{item?.expiryDate ? moment(item?.expiryDate).format(format) : "NA"}</span> */}
                                            </Col>
                                        </Row>
                                        <div className="bottom-border"></div>
                                    </div>
                                }

                                {(checkIsFleetOwner(detailData?.userRole) || checkIsFleetOwnerConverted(detailData?.userRole))?
                                    <>
                                        {checkIsTurkeyKazak(detailData?.operatingCountry)|| checkIsTurkeyKazak(detailData?.country) ?
                                              <>
                                              {detailData?.operatingCountry === "Kazakhstan"|| detailData?.country === "Kazakhstan" ? 
                                              <>
                                                  <div>
                                                      <Row gutter={16} className="data-row">
                                                          <Col span={9}>
                                                              <span>{t("VAT_CERTIFICATE_COMMON")}</span>
                                                          </Col>
                                                          <Col span={15} className="doc-file">

                                                              <Row justify={'end'} gutter={[16, 16]}>
                                                                  {supplierDocs?.tradeLicense?.frontDoc?.documentPath && <Col span={12}>
                                                                      <Fileupload
                                                                          accessFile={true}
                                                                          defaultThumbFile={supplierDocs?.tradeLicense?.frontDoc?.documentPath || ''}
                                                                          defaultFile={supplierDocs?.tradeLicense?.frontDoc?.documentPath || ''}
                                                                          readonly={true}>

                                                                      </Fileupload>
                                                                  </Col>}
                                                                  <Col span={12}>
                                                                      {supplierDocs?.tradeLicense?.backDoc?.documentPath && <Fileupload
                                                                          entityId={""}
                                                                          defaultThumbFile={supplierDocs ? supplierDocs?.tradeLicense?.backDoc?.documentPath : ""}
                                                                          defaultFile={supplierDocs ? supplierDocs?.tradeLicense?.backDoc?.documentPath : ""}
                                                                          readonly={true}
                                                                          accessFile={true}
                                                                      >
                                                                      </Fileupload>}
                                                                  </Col>
                                                              </Row>
                                                          </Col>
                                                      </Row>  <br />
                                                      <Row gutter={16} className="data-row">
                                                          <Col span={10}>
                                                              <span>{t("NUMBER_COMMON")}</span><br />
                                                              <span>{supplierDocs ? supplierDocs?.tradeLicense?.documentNumber : "NA"}</span>
                                                          </Col>
                                                          <Col span={14}>
                                                              <span>{t("FLEET_DRIVER_EXPIRY_DATE")}</span> <br />
                                                              <span>
                                                                  {supplierDocs?.tradeLicense?.expiryDate
                                                                      ? moment(supplierDocs.tradeLicense.expiryDate).format(format)
                                                                      : null}
                                                              </span>
                                                          </Col>
                                                      </Row>
                                                      <div className="bottom-border"></div>
                                                  </div>
                                              </>
                                                  :
                                                  <div>
                                                      <Row gutter={16} className="data-row">
                                                          <Col span={9}>
                                                              <span>{t("VAT_CERTIFICATE_COMMON")}</span>
                                                          </Col>
                                                          <Col span={15} className="doc-file">

                                                              <Row justify={'end'} gutter={[16, 16]}>
                                                                  {supplierDocs?.vatCertificate?.frontDoc?.documentPath && <Col span={12}>
                                                                      <Fileupload
                                                                          accessFile={true}
                                                                          defaultThumbFile={supplierDocs?.vatCertificate?.frontDoc?.documentPath || ''}
                                                                          defaultFile={supplierDocs?.vatCertificate?.frontDoc?.documentPath || ''}
                                                                          readonly={true}>

                                                                      </Fileupload>
                                                                  </Col>}
                                                                  <Col span={12}>
                                                                      {supplierDocs?.vatCertificate?.backDoc?.documentPath && <Fileupload
                                                                          entityId={""}
                                                                          defaultThumbFile={supplierDocs ? supplierDocs?.vatCertificate?.backDoc?.documentPath : ""}
                                                                          defaultFile={supplierDocs ? supplierDocs?.vatCertificate?.backDoc?.documentPath : ""}
                                                                          readonly={true}
                                                                          accessFile={true}
                                                                      >
                                                                      </Fileupload>}
                                                                  </Col>
                                                              </Row>
                                                          </Col>
                                                      </Row>  <br />
                                                      <Row gutter={16} className="data-row">
                                                          <Col span={10}>
                                                              <span>{t("NUMBER_COMMON")}</span><br />
                                                              <span>{supplierDocs ? supplierDocs?.vatCertificate?.documentNumber : "NA"}</span>
                                                          </Col>
                                                          <Col span={14}>
                                                              <span>{t("FLEET_DRIVER_EXPIRY_DATE")}</span> <br />
                                                              <span>
                                                                  {supplierDocs?.vatCertificate?.expiryDate
                                                                      ? moment(supplierDocs.vatCertificate.expiryDate).format(format)
                                                                      : null}
                                                              </span>
                                                          </Col>
                                                      </Row>
                                                      <div className="bottom-border"></div>
                                                  </div>}
                                              <Row gutter={16} className="data-row">
                                                  <Col span={14}>
                                                      <span>{t("ACCOUNT_IBAN_NO")}</span><br />
                                                      {supplierDocs?.iBanNo.map((iban, index) => (
                                                          <div key={index}>{iban}</div>
                                                      ))}
                                                  </Col>
                                                  <Col span={10}>
                                                      <span>{t("FILE_VERIFY_CERTIFICATE")}</span> <br />
                                                      <span>
                                                          {supplierDocs?.certification?.length > 0 ? supplierDocs?.certification[0] : ""}
                                                      </span>
                                                  </Col>
                                              </Row>
                                              {/* <div>
                                                  <span>IBAN Numbers</span><br />
                                                  {supplierDocs?.iBanNo.map((iban, index) => (
                                                      <div key={index}>{iban}</div>
                                                  ))}
                                              </div>
                                              <div>
                                                  <br />  <span>Certification</span><br />
                                                  {supplierDocs?.certification?.length > 0 ? supplierDocs?.certification[0] : ""}
                                              </div> */}

                                          </>
                                            :
                                        
                                            <>
                                            <span className='star-color'>{t("VAT_REGISTRATION_CERTIFICATE_LABEL")}<span>*</span></span>
                                            <Row>
                                                <Col>
                                                    <Form.Item name="vatUpload" className="floating-label-form-item"
                                                        rules={[
                                                            { required: true, message: t("VAT_DOC_UPLOAD_REQUIRED") },
                                                        ]}>
                                                        <Fileupload
                                                            filetype={DocTypes.VAT_FRONT}
                                                            defaultThumbFile={supplierDocs?.vatCertificate?.frontDoc?.documentPathThumb}
                                                            defaultFile={supplierDocs?.vatCertificate?.frontDoc?.documentPath}
                                                            fileName={supplierDocs?.vatCertificate?.frontDoc?.fileName}
                                                            entityId=''
                                                            accessFile={false}
                                                            readOnly={true} 
                                                            showOnly={true}
                                                      
                                                        // updateFormValue={(val)=>{ editSupplierForm.setFieldsValue({ vatUpload: val })}}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Form.Item
                                                name="vatNumber"
                                                rules={[{ required: true, message: t("VAT_REGISTRATION_REQUIRED") },
                                                { validator: validateNotEmpty('VAT Registration No.') },
                                                uniqueDocNumberRule("vatNumber")
                                                ]}
                                                className="floating-label-form-item"
                                            >
                                                <Input value={editSupplierForm.getFieldValue("vatNumber")} maxLength={20} style={{ width: '100%' }} className="floating-input" placeholder={t("VAT_REGISTRATION_NO_PLACEHOLDER")}
                                                 readOnly={true} 
                                                 showOnly={true}
                                                />
                                                <label className="floating-label">{t("VAT_REGISRATION_NUMBER")}<span>*</span></label>
                                            </Form.Item>
                                            <Form.Item
                                                name="vatExpiry"
                                                rules={[{ required: true, message: t("EXPIRY_DATE_YOUR_REQUIRED") }]}
                                                className="floating-label-form-item"
                                            >
                                                <DatePicker className="floating-input" format={format} placeholder={t("EXPIRY_DATE_ENTER_PLACEHOLDER")} disabledDate={disablePastDates}
                                                    value={editSupplierForm.getFieldValue("vatExpiry") ? dayjs(editSupplierForm.getFieldValue("vatExpiry"), format) : null}
                                                    readOnly={true} 
                                                 showOnly={true}
                                                />
                                                <label className="floating-label">{t("EXPIRY_DATE")} <span>*</span></label>
                                            </Form.Item>
                                            <span className='star-color'>Trade License<span>*</span></span>
                                            <Row>
                                                <Col>
                                                    <Form.Item name="tradeFont" className="floating-label-form-item"
                                                        rules={[
                                                            { required: true, message: t("UPLOAD_TRADE_LICENCE_DOC_REQUIRED") },
                                                        ]}>
                                                        <Fileupload
                                                            filetype={DocTypes.TRADE_LICENSE_FRONT}
                                                            defaultThumbFile={supplierDocs?.tradeLicense?.frontDoc?.documentPathThumb}
                                                            defaultFile={supplierDocs?.tradeLicense?.frontDoc?.documentPath}
                                                            fileName={supplierDocs?.tradeLicense?.frontDoc?.fileName}
                                                            entityId=''
                                                            entityType={EntityTypes.SUPPLIER}
                                                            accessFile={false}
                                                            readOnly={true} 
                                                            showOnly={true}
                                                        // updateFormValue={(val)=>{ editSupplierForm.setFieldsValue({ tradeFont: val })}}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Form.Item
                                                name="tradeDocumentNumber"
                                                rules={[{ required: true, message: t("TRADE_LICENCE_DOC_REQUIRED") },
                                                    // { validator: validateNotEmpty('VAT Registration No.') }
                                                ]}
                                                className="floating-label-form-item"
                                            >
                                                <Input value={editSupplierForm.getFieldValue("tradeDocumentNumber")} maxLength={20} style={{ width: '100%' }} className="floating-input" placeholder={t("SIGNUP_KYC_TRADE_LIC_NUM_PH")}
                                                     readOnly={true} 
                                                     showOnly={true}
                                                />
                                                <label className="floating-label">{t("ACCOUNT_KYC_DETAILS_TRADE_LICENSE_NO")} <span>*</span></label>
                                            </Form.Item>
                                            <Form.Item
                                                name="tradeExpiry"
                                                rules={[{ required: true, message: t("EXPIRY_DATE_YOUR_REQUIRED") }]}
                                                className="floating-label-form-item"
                                            >
                                                <DatePicker className="floating-input" format={format} placeholder={t("EXPIRY_DATE_ENTER_PLACEHOLDER")} disabledDate={disablePastDates}
                                                    value={editSupplierForm.getFieldValue("tradeExpiry") ? dayjs(editSupplierForm.getFieldValue("tradeExpiry"), format) : null}
                                                    readOnly={true} 
                                                    showOnly={true}
                                                />
                                                <label className="floating-label">{t("EXPIRY_DATE")} <span>*</span></label>
                                            </Form.Item>
                                        </>
                                        }
                                    </>:
                                   
                                       <>
                                        {/* PREVIEW Driving Licence */}
                                    <div>
                                        <Row gutter={16} className="data-row">
                                            <Col span={9}>
                                                <span>{t("DRIVING_LICENSE_LABEL")}</span>
                                            </Col>
                                            <Col span={15} className="doc-file">
                                                <Row justify={'end'} gutter={[16, 16]}>
                                                    {supplierDocs?.drivingLicense?.frontDoc?.documentPath && <Col span={12}>
                                                        <Fileupload
                                                            accessFile={true}
                                                            defaultThumbFile={supplierDocs?.drivingLicense?.frontDoc?.documentPath || ''}
                                                            defaultFile={supplierDocs?.drivingLicense?.frontDoc?.documentPath || ''}
                                                            readonly={true}>

                                                        </Fileupload>
                                                    </Col>}
                                                    <Col span={12}>
                                                        {supplierDocs?.drivingLicense?.backDoc?.documentPath && <Fileupload
                                                            entityId={""}
                                                            defaultThumbFile={supplierDocs ? supplierDocs?.drivingLicense?.backDoc?.documentPath : ""}
                                                            defaultFile={supplierDocs ? supplierDocs?.drivingLicense?.backDoc?.documentPath : ""}
                                                            readonly={true}
                                                            accessFile={true}
                                                        >
                                                        </Fileupload>}
                                                    </Col>

                                                    {/* <img style={{height:'5rem', width:'6vw'}} src={supplierDocs && supplierDocs?.drivingLicense?.frontDoc?.documentPath } />
                                    <img style={{height:'5rem'}}  src={supplierDocs ? supplierDocs?.drivingLicense?.backDoc?.documentPath : "" } ></img> */}
                                                </Row>
                                            </Col>
                                        </Row>  <br />
                                        <Row gutter={16} className="data-row">
                                            <Col span={10}>
                                                <span>{t("FLEET_DRIVER_DRIVING_LICENSE_NO")}</span><br />
                                                <span>{supplierDocs ? supplierDocs?.drivingLicense?.documentNumber : "NA"}</span>
                                            </Col>
                                            <Col span={14}>
                                                <span>{t("FLEET_DRIVER_EXPIRY_DATE")}</span> <br />
                                                <span>
                                                    {supplierDocs?.drivingLicense?.expiryDate
                                                        ? moment(supplierDocs.drivingLicense.expiryDate).format(format)
                                                        : null}
                                                </span>
                                            </Col>
                                        </Row>
                                        <div className="bottom-border"></div>
                                    </div>
                                    {/* PREVIEW National ID */}
                                    <div>
                                        <Row gutter={16} className="data-row">
                                            <Col span={9}>
                                                <span>{t("FLEET_DRIVER_NATIONAL_ID")}</span>
                                            </Col>
                                            <Col span={15} className="doc-file">

                                                <Row justify={'end'} gutter={[16, 16]}>
                                                    {supplierDocs?.nationalID?.frontDoc?.documentPath && <Col span={12}>
                                                        <Fileupload
                                                            accessFile={true}
                                                            defaultThumbFile={supplierDocs?.nationalID?.frontDoc?.documentPath || ''}
                                                            defaultFile={supplierDocs?.nationalID?.frontDoc?.documentPath || ''}
                                                            readonly={true}>

                                                        </Fileupload>
                                                    </Col>}
                                                    <Col span={12}>
                                                        {supplierDocs?.nationalID?.backDoc?.documentPath && <Fileupload
                                                            entityId={""}
                                                            defaultThumbFile={supplierDocs ? supplierDocs?.nationalID?.backDoc?.documentPath : ""}
                                                            defaultFile={supplierDocs ? supplierDocs?.nationalID?.backDoc?.documentPath : ""}
                                                            readonly={true}
                                                            accessFile={true}
                                                        >
                                                        </Fileupload>}
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row><br />
                                        <Row gutter={16} className="data-row">
                                            <Col span={10}>
                                                <span>{t("FLEET_DRIVER_NATIONAL_ID_NO")}</span><br />
                                                <span>{supplierDocs ? supplierDocs?.nationalID?.documentNumber : "NA"}</span>
                                            </Col>
                                            <Col span={14}>
                                                <span>{t("FLEET_DRIVER_EXPIRY_DATE")}</span> <br />
                                                <span>
                                                    {supplierDocs?.nationalID?.expiryDate
                                                        ? moment(supplierDocs.nationalID.expiryDate).format(format)
                                                        : null}
                                                </span>
                                            </Col>
                                        </Row>
                                        <div className="bottom-border"></div>
                                    </div>
                                     {/* PREVIEW PASSPORT */}
                                    {supplierDocs?.passport !== null && <div>
                                        <Row gutter={16} className="data-row">
                                            <Col span={9}>
                                                <span>{t("FLEET_DRIVER_PASSPORT")}</span>
                                            </Col>
                                            <Col span={15} className="doc-file">
                                                {/* <Row  justify={'end'}>
                                    
                                        <img style={{height:'5rem', width:'6vw'}} src={supplierDocs ? supplierDocs?.passport?.frontDoc?.documentPath : ""} />
                                    <img style={{height:'5rem'}}  src={supplierDocs ? supplierDocs?.passport?.backDoc?.documentPath : "" } ></img>
                                    </Row> */}
                                                <Row justify={'end'} gutter={[16, 16]}>
                                                    {supplierDocs?.passport?.frontDoc?.documentPath && <Col span={12}>
                                                        <Fileupload
                                                            accessFile={true}
                                                            defaultThumbFile={supplierDocs?.passport?.frontDoc?.documentPath || ''}
                                                            defaultFile={supplierDocs?.passport?.frontDoc?.documentPath || ''}
                                                            readonly={true}>

                                                        </Fileupload>
                                                    </Col>}
                                                    <Col span={12}>
                                                        {supplierDocs?.passport?.backDoc?.documentPath && <Fileupload
                                                            entityId={""}
                                                            defaultThumbFile={supplierDocs ? supplierDocs?.passport?.backDoc?.documentPath : ""}
                                                            defaultFile={supplierDocs ? supplierDocs?.passport?.backDoc?.documentPath : ""}
                                                            readonly={true}
                                                            accessFile={true}
                                                        >
                                                        </Fileupload>}
                                                    </Col>

                                                    {/* <img style={{height:'5rem', width:'6vw'}} src={supplierDocs && supplierDocs?.drivingLicense?.frontDoc?.documentPath } />
                                    <img style={{height:'5rem'}}  src={supplierDocs ? supplierDocs?.drivingLicense?.backDoc?.documentPath : "" } ></img> */}
                                                </Row>
                                            </Col>
                                        </Row>  <br />
                                        <Row gutter={16} className="data-row">
                                            <Col span={10}>
                                                <span>{t("FLEET_DRIVER_PASSPORT_NO")}</span><br />
                                                <span>{supplierDocs ? supplierDocs?.passport?.documentNumber : "NA"}</span>
                                            </Col>
                                            <Col span={14}>
                                                <span>{t("FLEET_DRIVER_EXPIRY_DATE")}</span> <br />
                                                <span>
                                                    {supplierDocs?.passport?.expiryDate
                                                        ? moment(supplierDocs?.passport.expiryDate).format(format)
                                                        : null}
                                                </span>
                                            </Col>
                                        </Row>
                                        <div className="bottom-border"></div>
                                    </div>
                                    }
                                    
                                    {/* PREVIEW VISA */}
                                    {supplierDocs?.visa.length > 0 && <div>
                                        {visa?.map((data, index) => (
                                            <div key={index}>
                                                {/* {visa?.length > 1 && index !== 0 && (
                                                    <Row
                                                        justify={"end"}
                                                        className="delete-visa"
                                                        onClick={() => {
                                                            const updatedVisa = [...visaArray];
                                                            updatedVisa.splice(index, 1);
                                                            setVisa(updatedVisa);
                                                        }}
                                                    >
                                                        Remove
                                                    </Row>
                                                )} */}

                                                {/* Front Document */}
                                                {data?.frontDoc && (
                                                    <Form.Item className="floating-label-form-item">
                                                        <Fileupload
                                                            filetype={DocTypes.VISA_FRONT}
                                                            defaultThumbFile={data?.frontDoc?.documentPathThumb}
                                                            defaultFile={data?.frontDoc?.documentPath}
                                                            fileName={data?.frontDoc?.fileName}
                                                            entityId={""}
                                                            entityType={EntityTypes.SUPPLIER}
                                                            accessFile={true}
                                                        // onChange={(value) => {
                                                        //     handleVisaDocumentChange(value, index, 0);  // 0 for frontDoc
                                                        // }}
                                                        />
                                                    </Form.Item>
                                                )}

                                                {/* Back Document */}
                                                {data?.backDoc && (
                                                    <Form.Item className="floating-label-form-item">
                                                        <Fileupload
                                                            filetype={DocTypes.VISA_BACK}
                                                            defaultThumbFile={data?.backDoc?.documentPathThumb}
                                                            defaultFile={data?.backDoc?.documentPath}
                                                            fileName={data?.backDoc?.fileName}
                                                            entityId={""}
                                                            entityType={EntityTypes.SUPPLIER}
                                                            accessFile={true}
                                                        // onChange={(value) => {
                                                        //     handleVisaDocumentChange(value, index, 1);  // 1 for backDoc
                                                        // }}
                                                        />
                                                    </Form.Item>
                                                )}

                                                {/* Add New Document Button */}
                                                {/* {data?.frontDoc && !data?.backDoc && (
                                                    <div style={{ display: "flex", justifyContent: "right" }}>
                                                        <Button
                                                            type="secondary"
                                                            icon={<PlusOutlined />}
                                                            className="add-doc"
                                                            onClick={() => addVisaDocument(index)}  // Add backDoc if only frontDoc exists
                                                        >
                                                            Add Visa Document
                                                        </Button>
                                                    </div>
                                                )} */}

                                                {/* Other Fields */}
                                                <Form.Item
                                                    className="floating-label-form-item"
                                                    name={["visa", index, "issuingCountry"]}
                                                    rules={[{ required: true, message: t("ISSUE_COUNTRY_VALIDATION") }]}
                                                >
                                                    <Select
                                                        name="issuingCountry"
                                                        className="floating-selectt"

                                                        showSearch
                                                        placeholder={t("ISSUING_COUNTRY_PLACEHOLDER")}
                                                        value={data?.issuingCountry}
                                                        fieldNames={{ label: "name", value: "name" }}


                                                        filterOption={(input, option) =>
                                                            option.name.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                        }
                                                    />
                                                    <label className="floating-label">
                                                        {t("ACCOUNT_ISSUNING_COUNTRY")} <span></span>
                                                    </label>
                                                </Form.Item>

                                                <Form.Item
                                                    name={["visa", index, "documentNumber"]}
                                                    className="floating-label-form-item"
                                                    rules={[{ required: true, message: t("VISA_NO_REQUIRED")}]}
                                                >
                                                    <Input
                                                        value={data?.documentNumber || ""}
                                                        style={{ width: "100%" }}
                                                        className="floating-input"
                                                        placeholder="Enter Visa Number"
                                                        maxLength={20}
                                                    // onChange={(e) => {
                                                    //     handleFormChange("documentNumber", e.target.value);
                                                    //     handleVisa({ documentNumber: e.target.value }, index);
                                                    // }}
                                                    />
                                                    <label className="floating-label">
                                                        {t("FLEET_DRIVER_VISA_NO")} <span></span>
                                                    </label>
                                                </Form.Item>

                                                <Form.Item
                                                    className="floating-label-form-item"
                                                    name={["visa", index, "expiryDate"]}
                                                    rules={[{ required: true, message: t("EXPIRY_DATE_REQUIRED") }]}
                                                >
                                                    <DatePicker
                                                        className="floating-input"
                                                        format={format}
                                                        placeholder="Enter Expiry Date Here"
                                                        disabledDate={disablePastDates}
                                                        value={
                                                            data?.expiryDate
                                                                ? dayjs(data.expiryDate, "YYYY-MM-DD").isValid()
                                                                    ? dayjs(data.expiryDate, "YYYY-MM-DD")
                                                                    : dayjs(data.expiryDate, "DD/MM/YYYY")
                                                                : null
                                                        }
                                                    // onChange={(date, dateString) => {
                                                    //     handleFormChange("expiryDate", dateString);
                                                    //     handleVisa({ expiryDate: dateString }, index);
                                                    // }}
                                                    />
                                                    <label className="floating-label">
                                                        {t("ACCOUNT_KYC_DETAILS_EXPIRY_DATE")} <span></span>
                                                    </label>
                                                </Form.Item>
                                            </div>
                                        ))}


                                    </div>}
                                </>
                                     
                               
                                }

                              
                            </div>
                            {/* } */}
                        </Card>
                    </Col>
                </Row>
            </div>}
                  {/* *********** EDIT MODAL ************** */}
            {isEditModalOpen && (
                <Modal width={'33rem'} open={isEditModalOpen} centered maskClosable={false} 
                // onCancel={() => { setIsEditModalOpen(false); setBtnLoader(false) }}
                onCancel={() => {
                    setIsEditModalOpen(false);
                    setBtnLoader(false);
                    setEditSupplierDocs(null);
                }}
                    title={<div> {t("EDIT_SUPPLIER_COMMON_BTN")} <span className='title-span'>
                    </span></div>}
                    footer={false}>
                    <div>
                        <Form layout="vertical" form={editSupplierForm} className="ant-form">
                            <div className='truck-form-scroll'>
                                {(checkIsFleetOwner(detailData?.userRole) || checkIsFleetOwnerConverted(detailData?.userRole)) ?
                                    <> {checkIsTurkeyKazak(detailData?.operatingCountry)|| checkIsTurkeyKazak(detailData?.country) ?
                                        <>
                                            <span className='star-color'>{t("SUPPLIER_VAT/REGISTRATION_CERTIFICATE")}<span>*</span></span>
                                            {detailData?.operatingCountry == "Kazakhstan" ? <>
                                                <Row>
                                                    <Col>
                                                        {/* <Form.Item className="floating-label-form-item"
                                                            name="tradeFont"
                                                            rules={[
                                                                { required: true, message: t("VAT_DOC_UPLOAD_REQUIRED") },
                                                            ]}
                                                        >
                                                            <Fileupload
                                                                filetype={DocTypes.TRADE_LICENSE_FRONT}
                                                                defaultThumbFile={supplierDocs?.tradeLicense?.frontDoc?.documentPathThumb}
                                                                defaultFile={supplierDocs?.tradeLicense?.frontDoc?.documentPath}
                                                                fileName={supplierDocs?.tradeLicense?.frontDoc?.fileName}
                                                                entityId=''
                                                                entityType={EntityTypes.SUPPLIER}
                                                                accessFile={false}
                                                                onChange={(value) => {
                                                                    onFileUploadDocs(value, 'tradeFont');
                                                                }}
                                                            // updateFormValue={(val)=>{ editSupplierForm.setFieldsValue({ tradeFont: val })}}
                                                            />
                                                        </Form.Item> */}
                                                        {/* **** OCR File Trade Licence***** */}
                                                        <Form.Item
                                                            className="floating-label-form-item"
                                                            name="tradeFont"
                                                            rules={[
                                                            {
                                                                required: true,
                                                                message: t("VAT_DOC_UPLOAD_REQUIRED"),
                                                            },
                                                            ]}
                                                            valuePropName="value"
                                                            getValueFromEvent={(e) => {
                                                            // if your component emits [ { file, fileThumbUrl } ]
                                                            if (Array.isArray(e) && e.length > 0) {
                                                                return {
                                                                // File: e[0].file,
                                                                // FileThumbURL: e[0].fileThumbUrl,
                                                                };
                                                            }
                                                            return e;
                                                            }}
                                                        >
                                                            <OCRFilePreviewUploader
                                                            filetype={DocTypes.TRADE_LICENSE_FRONT}
                                                            defaultThumbFile={
                                                                editSupplierDocs?.tradeLicense?.frontDoc
                                                                ?.documentPathThumb
                                                            }
                                                            defaultFile={
                                                                editSupplierDocs?.tradeLicense?.frontDoc
                                                                ?.documentPath
                                                            }
                                                            fileName={
                                                                editSupplierDocs?.tradeLicense?.frontDoc
                                                                ?.fileName
                                                            }
                                                            entityId=""
                                                            entityType={EntityTypes.SUPPLIER}
                                                            accessFile={false}
                                                            // onChange={(value) => {
                                                            //   onFileUploadDocs(value, "vatUpload");
                                                            // }}
                                                            onChange={(newFiles) =>
                                                                handleOCRConformFileChange(
                                                                newFiles,
                                                                "tradeFont",
                                                                OCRFieldNames.TRADE_LICENSE,
                                                                DocTypes.TRADE_LICENSE_FRONT
                                                                )
                                                            }
                                                            onDelete={() =>
                                                                handleEditingDeleteFile(
                                                                "tradeFont",
                                                                OCRFieldNames.TRADE_LICENSE
                                                                )
                                                            }
                                                            />
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                                <Form.Item
                                                    name="tradeDocumentNumber"
                                                    rules={[{ required: true, message: t("VAT_REGISTRATION_REQUIRED") },
                                                    { validator: validateNotEmpty('VAT Registration No.') },
                                                    uniqueDocNumberRule("tradeDocumentNumber")
                                                    ]}
                                                    className="floating-label-form-item"
                                                >
                                                    <Input value={editSupplierForm.getFieldValue("tradeDocumentNumber")} maxLength={20} style={{ width: '100%' }} className="floating-input" placeholder={t("VAT_REGISTRATION_NO_PLACEHOLDER")}
                                                        onChange={(e) => handleFormChange("tradeDocumentNumber", e.target.value)}
                                                    />
                                                    <label className="floating-label">{t("VAT_REGISTRATION_NO_SUPPLIER_LABEL")} <span>*</span></label>
                                                </Form.Item>
                                                <Form.Item
                                                    name="tradeExpiry"
                                                    rules={[{ required: true, message: t("EXPIRY_DATE_YOUR_REQUIRED") }]}
                                                    className="floating-label-form-item"
                                                >
                                                    <DatePicker className="floating-input" format={format} placeholder={t("EXPIRY_DATE_ENTER_PLACEHOLDER")} disabledDate={disablePastDates}
                                                        value={editSupplierForm.getFieldValue("vatExpiry") ? dayjs(editSupplierForm.getFieldValue("tradeExpiry"), format) : null}
                                                        onChange={(date, dateString) => handleFormChange("tradeExpiry", dateString)}
                                                    />
                                                    <label className="floating-label">{t("EXPIRY_DATE")} <span>*</span></label>
                                                </Form.Item>
                                            </> : <>
                                                <Row>
                                                    <Col>
                                                        {/* <Form.Item className="floating-label-form-item"
                                                            name="vatUpload"
                                                            rules={[
                                                                { required: true, message: t("VAT_DOC_UPLOAD_REQUIRED") },
                                                            ]}
                                                        >
                                                            <Fileupload
                                                                filetype={DocTypes.VAT_FRONT}
                                                                defaultThumbFile={supplierDocs?.vatCertificate?.frontDoc?.documentPathThumb}
                                                                defaultFile={supplierDocs?.vatCertificate?.frontDoc?.documentPath}
                                                                fileName={supplierDocs?.vatCertificate?.frontDoc?.fileName}
                                                                entityId=''
                                                                accessFile={false}
                                                                onChange={(value) => {
                                                                    onFileUploadDocs(value, 'vatUpload');
                                                                }}
                                                            //updateFormValue={(val)=>{ editSupplierForm.setFieldsValue({ vatUpload: val })}}
                                                            />
                                                        </Form.Item> */}
                                                        {/* **** OCR File Upload Vat Registration Certificate ***** */}
                                                        <Form.Item
                                                            className="floating-label-form-item"
                                                            name="vatUpload"
                                                            rules={[
                                                            {
                                                                required: true,
                                                                message: t("VAT_DOC_UPLOAD_REQUIRED"),
                                                            },
                                                            ]}
                                                            valuePropName="value"
                                                            getValueFromEvent={(e) => {
                                                            // if your component emits [ { file, fileThumbUrl } ]
                                                            if (Array.isArray(e) && e.length > 0) {
                                                                return {
                                                                // File: e[0].file,
                                                                // FileThumbURL: e[0].fileThumbUrl,
                                                                };
                                                            }
                                                            return e;
                                                            }}
                                                        >
                                                            <OCRFilePreviewUploader
                                                            filetype={DocTypes.VAT_FRONT}
                                                            defaultThumbFile={
                                                                editSupplierDocs?.vatCertificate?.frontDoc
                                                                ?.documentPathThumb
                                                            }
                                                            defaultFile={
                                                                editSupplierDocs?.vatCertificate?.frontDoc
                                                                ?.documentPath
                                                            }
                                                            fileName={
                                                                editSupplierDocs?.vatCertificate?.frontDoc
                                                                ?.fileName
                                                            }
                                                            entityId=""
                                                            accessFile={false}
                                                            // onChange={(value) => {
                                                            //   onFileUploadDocs(value, "vatUpload");
                                                            // }}
                                                            onChange={(newFiles) =>
                                                                handleOCRConformFileChange(
                                                                newFiles,
                                                                "vatUpload",
                                                                OCRFieldNames.VAT_CERTIFICATE,
                                                                DocTypes.VAT_FRONT
                                                                )
                                                            }
                                                            onDelete={() =>
                                                                handleEditingDeleteFile(
                                                                "vatUpload",
                                                                OCRFieldNames.VAT_CERTIFICATE
                                                                )
                                                            }
                                                            />
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                                <Form.Item
                                                    name="vatNumber"
                                                    rules={[{ required: true, message: t("VAT_REGISTRATION_REQUIRED") },
                                                    { validator: validateNotEmpty('VAT Registration No.') },
                                                    uniqueDocNumberRule("vatNumber")
                                                    ]}
                                                    className="floating-label-form-item"
                                                >
                                                    <Input value={editSupplierForm.getFieldValue("vatNumber")} maxLength={20} style={{ width: '100%' }} className="floating-input" placeholder={t("VAT_REGISTRATION_NO_PLACEHOLDER")}
                                                        onChange={(e) => handleFormChange("vatNumber", e.target.value)}
                                                    />
                                                    <label className="floating-label">{t("VAT_REGISTRATION_NO_SUPPLIER_LABEL")} <span>*</span></label>
                                                </Form.Item>
                                                <Form.Item
                                                    name="vatExpiry"
                                                    rules={[{ required: true, message: t("EXPIRY_DATE_YOUR_REQUIRED") }]}
                                                    className="floating-label-form-item"
                                                >
                                                    <DatePicker className="floating-input" format={format} placeholder={t("EXPIRY_DATE_ENTER_PLACEHOLDER")} disabledDate={disablePastDates}
                                                        value={editSupplierForm.getFieldValue("vatExpiry") ? dayjs(editSupplierForm.getFieldValue("vatExpiry"), format) : null}
                                                        onChange={(date, dateString) => handleFormChange("vatExpiry", dateString)}
                                                    />
                                                    <label className="floating-label">{t("EXPIRY_DATE")} <span>*</span></label>
                                                </Form.Item>
                                            </>}
                                            <Form.Item
                                                name="registrationOffice"
                                                rules={[{ required: true, message: t("REGISTRATION_OFFICE_REQUIRED") }]}
                                                className="floating-label-form-item"
                                            >
                                                <Input placeholder={t("REGISTRATION_OFFICE_PLACEHOLDER")}className="floating-input" maxLength={20} value={editSupplierForm.getFieldValue("registrationOffice")}
                                                    onChange={e => handleFormChange('registrationOffice', e.target.value)}
                                                />
                                                <label className="floating-label">{t("REGISTRATION_OFFICE_LABEL")}<b className="mandate-color">*</b></label>
                                            </Form.Item>
                                            <label className='registration-lable'>{t("REGISTRATION_DISTRICT_OFFICE_TAX_LABEL")}</label>
                                            <Row style={{ margin: "5px 0 0 0" }}>
                                                <Col className='col-name'>
                                                    {t("FILE_VERIFY_IBAN_CERTIFICATE_NUMBER")}
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col span={11}>
                                                    {ibanNumber?.map((ele, index) => <>
                                                        <Form.Item
                                                            name={"iBanNo_" + index}
                                                            rules={[{ required: true, message:t("IBAN_REQUIRED")  },
                                                            {
                                                                pattern: new RegExp("^[a-zA-Z0-9\-]+$"),
                                                                message: t("CORRECT_FORMAT_VALIDATION"),
                                                            },
                                                            ({ getFieldValue }) => ({
                                                                validator(_, value) {
                                                                    const ibanlength = detailData?.operatingCountry === 'Kazakhstan' ? 20
                                                                        : detailData?.operatingCountry === 'Turkey' ? 26
                                                                            : 34;
                                                                    if (!value) {
                                                                        return Promise.reject(t("IBAN_REQUIRED"))
                                                                    } if (value.length !== ibanlength) {
                                                                        return Promise.reject(`${t("IBAN_LENGTH_VALIDATION")} ${ibanlength} `)
                                                                    }
                                                                    return Promise.resolve();
                                                                }
                                                            })

                                                            ]}

                                                            className="floating-label-form-item"
                                                        >
                                                            <Input placeholder={t("IBAN_PLACEHOLDER")} className="floating-input" maxLength={detailData?.operatingCountry === 'Kazakhstan' ? 20 : detailData?.operatingCountry === 'Turkey' ? 26 : 34}
                                                                value={ibanNumber[index]}
                                                                onChange={(e) => {
                                                                    handleIbanNumberChange(e.target.value, index)
                                                                }}
                                                            />
                                                            <label className="floating-label">{t("IBAN_NUMBER_KEY")}<b className="mandate-color">*</b></label>
                                                        </Form.Item>
                                                    </>)}

                                                    <Row gutter={16}>
                                                        <Col span={16}>
                                                            <label className='registration-lable'>{t("MUST_BE_KEY")}{detailData?.operatingCountry === 'Kazakhstan' ? "20" : detailData?.operatingCountry === 'Turkey' ? "26" : "34"} {t("ACCOUNT_DIGITS")}</label>
                                                        </Col>
                                                        <Col span={8}>
                                                            <Button type='secondary'
                                                                icon={<PlusOutlined />}
                                                                className="add-doc"
                                                                onClick={addIbanNumber}
                                                            >
                                                                {t("ACCOUNT_ADD_IBAN")}
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col span={12} className='col-item'>
                                                    <Form.Item
                                                        name="certification"
                                                        rules={[{ required: true, message: t("CERTIFICATION_REQUIRED") }]}
                                                        className="floating-label-form-item"
                                                    >
                                                        <Select
                                                            className="floating-selectt"
                                                            value={editSupplierForm.getFieldValue("certification")}
                                                            options={[
                                                                { label: 'K1', value: 'K1' },
                                                                { label: 'C2', value: 'C2' },
                                                            ]}
                                                            onChange={(value) => {
                                                                handleFormChange("certification", [value]);
                                                            }}
                                                            style={{ width: "100%", height: "56px" }}
                                                        />
                                                        <label className="floating-label">{t("CERTIFICATIONS_LABEL")}<b className="mandate-color">*</b></label>
                                                    </Form.Item>

                                                </Col>
                                            </Row>
                                        </>
                                        :
                                        <>
                                            <span className='star-color'>{t("VAT_REGISTRATION_CERTIFICATE_LABEL")}<span>*</span></span>
                                            <Row>
                                                <Col>
                                                    {/* <Form.Item name="vatUpload" className="floating-label-form-item"
                                                        rules={[
                                                            { required: true, message: t("VAT_DOC_UPLOAD_REQUIRED") },
                                                        ]}>
                                                        <Fileupload
                                                            filetype={DocTypes.VAT_FRONT}
                                                            defaultThumbFile={supplierDocs?.vatCertificate?.frontDoc?.documentPathThumb}
                                                            defaultFile={supplierDocs?.vatCertificate?.frontDoc?.documentPath}
                                                            fileName={supplierDocs?.vatCertificate?.frontDoc?.fileName}
                                                            entityId=''
                                                            accessFile={false}
                                                            onChange={(value) => {
                                                                onFileUploadDocs(value, 'vatUpload');
                                                            }}
                                                        // updateFormValue={(val)=>{ editSupplierForm.setFieldsValue({ vatUpload: val })}}
                                                        />
                                                    </Form.Item> */}
                                                    {/* **** OCR File Upload Vat Registration Certificate ***** */}
                                                    <Form.Item
                                                    name="vatUpload"
                                                    className="floating-label-form-item"
                                                    rules={[
                                                        {
                                                        required: true,
                                                        message: t("VAT_DOC_UPLOAD_REQUIRED"),
                                                        },
                                                    ]}
                                                    valuePropName="value"
                                                    getValueFromEvent={(e) => {
                                                        // if your component emits [ { file, fileThumbUrl } ]
                                                        if (Array.isArray(e) && e.length > 0) {
                                                        return {
                                                            // File: e[0].file,
                                                            // FileThumbURL: e[0].fileThumbUrl,
                                                        };
                                                        }
                                                        return e;
                                                    }}
                                                    >
                                                    <OCRFilePreviewUploader
                                                        filetype={DocTypes.VAT_FRONT}
                                                        defaultThumbFile={
                                                        editSupplierDocs?.vatCertificate?.frontDoc
                                                            ?.documentPathThumb
                                                        }
                                                        defaultFile={
                                                        editSupplierDocs?.vatCertificate?.frontDoc
                                                            ?.documentPath
                                                        }
                                                        fileName={
                                                        editSupplierDocs?.vatCertificate?.frontDoc
                                                            ?.fileName
                                                        }
                                                        entityId=""
                                                        accessFile={false}
                                                        // onChange={(value) => {
                                                        //   onFileUploadDocs(value, "vatUpload");
                                                        // }}
                                                        onChange={(newFiles) =>
                                                        handleOCRConformFileChange(
                                                            newFiles,
                                                            "vatUpload",
                                                            OCRFieldNames.VAT_CERTIFICATE,
                                                            DocTypes.VAT_FRONT
                                                        )
                                                        }
                                                        onDelete={() =>
                                                        handleEditingDeleteFile(
                                                            "vatUpload",
                                                            OCRFieldNames.VAT_CERTIFICATE
                                                        )
                                                        }
                                                    />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Form.Item
                                                name="vatNumber"
                                                rules={[{ required: true, message: t("VAT_REGISTRATION_REQUIRED") },
                                                { validator: validateNotEmpty('VAT Registration No.') },
                                                uniqueDocNumberRule("vatNumber")
                                                ]}
                                                className="floating-label-form-item"
                                            >
                                                <Input value={editSupplierForm.getFieldValue("vatNumber")} maxLength={20} style={{ width: '100%' }} className="floating-input" placeholder={t("VAT_REGISTRATION_NO_PLACEHOLDER")}
                                                    onChange={(e) => handleFormChange("vatNumber", e.target.value)}
                                                />
                                                <label className="floating-label">{t("VAT_REGISRATION_NUMBER")}<span>*</span></label>
                                            </Form.Item>
                                            <Form.Item
                                                name="vatExpiry"
                                                rules={[{ required: true, message: t("EXPIRY_DATE_YOUR_REQUIRED") }]}
                                                className="floating-label-form-item"
                                            >
                                                <DatePicker className="floating-input" format={format} placeholder={t("EXPIRY_DATE_ENTER_PLACEHOLDER")} disabledDate={disablePastDates}
                                                    value={editSupplierForm.getFieldValue("vatExpiry") ? dayjs(editSupplierForm.getFieldValue("vatExpiry"), format) : null}
                                                    onChange={(date, dateString) => handleFormChange("vatExpiry", dateString)}
                                                />
                                                <label className="floating-label">{t("EXPIRY_DATE")} <span>*</span></label>
                                            </Form.Item>
                                            {/* ******** Trade License *********** */}
                                            <span className='star-color'>Trade License<span>*</span></span>
                                            <Row>
                                                <Col>
                                                    {/* <Form.Item name="tradeFont" className="floating-label-form-item"
                                                        rules={[
                                                            { required: true, message: t("UPLOAD_TRADE_LICENCE_DOC_REQUIRED") },
                                                        ]}>
                                                        <Fileupload
                                                            filetype={DocTypes.TRADE_LICENSE_FRONT}
                                                            defaultThumbFile={supplierDocs?.tradeLicense?.frontDoc?.documentPathThumb}
                                                            defaultFile={supplierDocs?.tradeLicense?.frontDoc?.documentPath}
                                                            fileName={supplierDocs?.tradeLicense?.frontDoc?.fileName}
                                                            entityId=''
                                                            entityType={EntityTypes.SUPPLIER}
                                                            accessFile={false}
                                                            onChange={(value) => {
                                                                onFileUploadDocs(value, 'tradeFont');
                                                            }}
                                                        // updateFormValue={(val)=>{ editSupplierForm.setFieldsValue({ tradeFont: val })}}
                                                        />
                                                    </Form.Item> */}
                                                    {/* **** OCR File Upload Trade License ***** */}
                                                    <Form.Item
                                                        name="tradeFont"
                                                        className="floating-label-form-item"
                                                        rules={[
                                                        {
                                                            required: true,
                                                            message: t(
                                                            "UPLOAD_TRADE_LICENCE_DOC_REQUIRED"
                                                            ),
                                                        },
                                                        ]}
                                                        valuePropName="value"
                                                        getValueFromEvent={(e) => {
                                                        // if your component emits [ { file, fileThumbUrl } ]
                                                        if (Array.isArray(e) && e.length > 0) {
                                                            return {
                                                            // File: e[0].file,
                                                            // FileThumbURL: e[0].fileThumbUrl,
                                                            };
                                                        }
                                                        return e;
                                                        }}
                                                    >
                                                        <OCRFilePreviewUploader
                                                        filetype={DocTypes.TRADE_LICENSE_FRONT}
                                                        defaultThumbFile={
                                                            editSupplierDocs?.tradeLicense?.frontDoc
                                                            ?.documentPathThumb
                                                        }
                                                        defaultFile={
                                                            editSupplierDocs?.tradeLicense?.frontDoc
                                                            ?.documentPath
                                                        }
                                                        fileName={
                                                            editSupplierDocs?.tradeLicense?.frontDoc
                                                            ?.fileName
                                                        }
                                                        entityId=""
                                                        entityType={EntityTypes.SUPPLIER}
                                                        accessFile={false}
                                                        // onChange={(value) => {
                                                        //   onFileUploadDocs(value, "vatUpload");
                                                        // }}
                                                        onChange={(newFiles) =>
                                                            handleOCRConformFileChange(
                                                            newFiles,
                                                            "tradeFont",
                                                            OCRFieldNames.TRADE_LICENSE
                                                            )
                                                        }
                                                        onDelete={() =>
                                                            handleEditingDeleteFile(
                                                            "tradeFont",
                                                            OCRFieldNames.TRADE_LICENSE
                                                            )
                                                        }
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Form.Item
                                                name="tradeDocumentNumber"
                                                rules={[{ required: true, message: t("TRADE_LICENCE_DOC_REQUIRED") },
                                                    // { validator: validateNotEmpty('VAT Registration No.') }
                                                ]}
                                                className="floating-label-form-item"
                                            >
                                                <Input value={editSupplierForm.getFieldValue("tradeDocumentNumber")} maxLength={20} style={{ width: '100%' }} className="floating-input" placeholder={t("SIGNUP_KYC_TRADE_LIC_NUM_PH")}
                                                    onChange={(e) => handleFormChange("tradeDocumentNumber", e.target.value)}
                                                />
                                                <label className="floating-label">{t("ACCOUNT_KYC_DETAILS_TRADE_LICENSE_NO")} <span>*</span></label>
                                            </Form.Item>
                                            <Form.Item
                                                name="tradeExpiry"
                                                rules={[{ required: true, message: t("EXPIRY_DATE_YOUR_REQUIRED") }]}
                                                className="floating-label-form-item"
                                            >
                                                <DatePicker className="floating-input" format={format} placeholder={t("EXPIRY_DATE_ENTER_PLACEHOLDER")} disabledDate={disablePastDates}
                                                    value={editSupplierForm.getFieldValue("tradeExpiry") ? dayjs(editSupplierForm.getFieldValue("tradeExpiry"), format) : null}
                                                    onChange={(date, dateString) => handleFormChange("tradeExpiry", dateString)}
                                                />
                                                <label className="floating-label">{t("EXPIRY_DATE")} <span>*</span></label>
                                            </Form.Item>
                                        </>
                                    }</>
                                    :
                                    <>
                                        <span className='star-color'>{t("FLEET_DRIVER_DRIVING_LICENSE")} <span>*</span></span>
                                        {/* ********UAE -- Edit Driving License ********* */}
                                        <Row gutter={16}>
                                            <Col span={12}>
                                                {/* <Form.Item name="licenceFront" className="floating-label-form-item"
                                                    rules={[
                                                        { required: true, message: t("UPLOAD_LICENCE_FRONT_REQUIRED")},
                                                    ]}>
                                                    <Fileupload
                                                        filetype={DocTypes.DL_FRONT}
                                                        defaultThumbFile={supplierDocs?.drivingLicense?.frontDoc?.documentPathThumb}
                                                        defaultFile={supplierDocs?.drivingLicense?.frontDoc?.documentPath}
                                                        fileName={supplierDocs?.drivingLicense?.frontDoc?.fileName}
                                                        entityId=''
                                                        entityType={EntityTypes.SUPPLIER}
                                                        accessFile={false}
                                                        name={t("KYC_UPLOAD_FRONT_LBL")}
                                                        onChange={(value) => {
                                                            onFileUploadDocs(value, 'licenceFront');
                                                        }}
                                                    // updateFormValue={(val) => { editSupplierForm.setFieldsValue({ licenceFront: val }) }}
                                                    />
                                                </Form.Item> */}
                                                {/* **** OCR File Upload  Driving License FRONT***** */}
                                                <Form.Item
                                                    name="licenceFront"
                                                    className="floating-label-form-item"
                                                    rules={[
                                                    {
                                                        required: true,
                                                        message: t("UPLOAD_LICENCE_FRONT_REQUIRED"),
                                                    },
                                                    ]}
                                                    valuePropName="value"
                                                    getValueFromEvent={(e) => {
                                                    // if your component emits [ { file, fileThumbUrl } ]
                                                    if (Array.isArray(e) && e.length > 0) {
                                                        return {
                                                        // File: e[0].file,
                                                        // FileThumbURL: e[0].fileThumbUrl,
                                                        };
                                                    }
                                                    return e;
                                                    }}
                                                >
                                                    <OCRFilePreviewUploader
                                                    filetype={DocTypes.DL_FRONT}
                                                    defaultThumbFile={
                                                        editSupplierDocs?.drivingLicense?.frontDoc
                                                        ?.documentPathThumb
                                                    }
                                                    defaultFile={
                                                        editSupplierDocs?.drivingLicense?.frontDoc
                                                        ?.documentPath
                                                    }
                                                    fileName={
                                                        editSupplierDocs?.drivingLicense?.frontDoc
                                                        ?.fileName
                                                    }
                                                    entityId=""
                                                    entityType={EntityTypes.SUPPLIER}
                                                    accessFile={false}
                                                    // onChange={(value) => {
                                                    //   onFileUploadDocs(value, "vatUpload");
                                                    // }}
                                                    name={t("KYC_UPLOAD_FRONT_LBL")}
                                                    onChange={(newFiles) =>
                                                        handleOCRConformFileChange(
                                                        newFiles,
                                                        "licenceFront",
                                                        OCRFieldNames.DRIVING_LICENSE,
                                                        DocTypes.DL_FRONT
                                                        )
                                                    }
                                                    onDelete={() =>
                                                        handleEditingDeleteFile(
                                                        "licenceFront",
                                                        OCRFieldNames.DRIVING_LICENSE
                                                        )
                                                    }
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                {/* <Form.Item name="licenceBack" className="floating-label-form-item"
                                                    rules={[
                                                        { required: true, message: t("UPLOAD_LICENCE_BACK_REQUIRED")},
                                                    ]}>
                                                    <Fileupload
                                                        filetype={DocTypes.DL_BACK}
                                                        defaultThumbFile={supplierDocs?.drivingLicense?.backDoc?.documentPathThumb}
                                                        defaultFile={supplierDocs?.drivingLicense?.backDoc?.documentPath}
                                                        fileName={supplierDocs?.drivingLicense?.backDoc?.fileName}
                                                        entityId=''
                                                        entityType={EntityTypes.SUPPLIER}
                                                        accessFile={false}
                                                        name={t("KYC_UPLOAD_BACK_LBL")}
                                                        onChange={(value) => {
                                                            onFileUploadDocs(value, 'licenceBack');
                                                        }}
                                                    // updateFormValue={(val) => { editSupplierForm.setFieldsValue({ licenceBack: val }) }}
                                                    />
                                                </Form.Item> */}
                                                 {/* **** OCR File Upload Driving License BACK***** */}
                                                <Form.Item
                                                    name="licenceBack"
                                                    className="floating-label-form-item"
                                                    rules={[
                                                    {
                                                        required: true,
                                                        message: t("UPLOAD_LICENCE_BACK_REQUIRED"),
                                                    },
                                                    ]}
                                                    valuePropName="value"
                                                    getValueFromEvent={(e) => {
                                                    // if your component emits [ { file, fileThumbUrl } ]
                                                    if (Array.isArray(e) && e.length > 0) {
                                                        return {
                                                        // File: e[0].file,
                                                        // FileThumbURL: e[0].fileThumbUrl,
                                                        };
                                                    }
                                                    return e;
                                                    }}
                                                >
                                                    <OCRFilePreviewUploader
                                                    filetype={DocTypes.DL_BACK}
                                                    defaultThumbFile={
                                                        editSupplierDocs?.drivingLicense?.backDoc
                                                        ?.documentPathThumb
                                                    }
                                                    defaultFile={
                                                        editSupplierDocs?.drivingLicense?.backDoc
                                                        ?.documentPath
                                                    }
                                                    fileName={
                                                        editSupplierDocs?.drivingLicense?.backDoc
                                                        ?.fileName
                                                    }
                                                    entityId=""
                                                    entityType={EntityTypes.SUPPLIER}
                                                    accessFile={false}
                                                    name={t("KYC_UPLOAD_BACK_LBL")}
                                                    onChange={(newFiles) =>
                                                        handleOCRConformFileChange(
                                                        newFiles,
                                                        "licenceBack",
                                                        OCRFieldNames.DRIVING_LICENSE,
                                                        DocTypes.DL_BACK
                                                        )
                                                    }
                                                    onDelete={() =>
                                                        handleEditingDeleteFile(
                                                        "licenceBack",
                                                        OCRFieldNames.DRIVING_LICENSE
                                                        )
                                                    }
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <Form.Item
                                            name="drivingLicenseNumber"
                                            rules={[{ required: true, message: t("DRIVING_LICENCE_NO_REQUIRED") },
                                            { validator: validateNotEmpty('driving license number') },
                                            uniqueDocNumberRule("drivingLicenseNumber")
                                            ]}
                                            className="floating-label-form-item"
                                        >
                                            <Input value={editSupplierForm.getFieldValue("drivingLicenseNumber")} maxLength={20} style={{ width: '100%' }} className="floating-input" placeholder="Enter Driving License Number"
                                                onChange={(e) => handleFormChange("drivingLicenseNumber", e.target.value)}
                                            />
                                            <label className="floating-label">{t("FLEET_DRIVER_DRIVING_LICENSE_NO")} <span>*</span></label>
                                        </Form.Item>
                                        <Form.Item
                                            name="licenseExpiry"
                                            rules={[{ required: true, message: t("EXPIRY_DATE_YOUR_REQUIRED") }]}
                                            className="floating-label-form-item"
                                        >
                                            <DatePicker className="floating-input" format={format} placeholder={t("EXPIRY_DATE_ENTER_PLACEHOLDER")} disabledDate={disablePastDates}
                                                value={editSupplierForm.getFieldValue("licenseExpiry") ? dayjs(editSupplierForm.getFieldValue("licenseExpiry"), format) : null}
                                                onChange={(date, dateString) => handleFormChange("licenseExpiry", dateString)}
                                            />
                                            <label className="floating-label">{t("FLEET_DRIVER_EXPIRY_DATE")} <span>*</span></label>
                                        </Form.Item>
                                        <span className='star-color'>{t("FLEET_DRIVER_NATIONAL_ID")} <span>*</span></span>
                                        {/* ********** UAE -- Edit National ID ********** */}
                                        <Row gutter={16}>
                                            <Col span={12}>
                                                {/* <Form.Item name="nationalIdFront" className="floating-label-form-item"
                                                    rules={[
                                                        { required: true, message: t("NATIONAL_ID_FRONT_UPLOAD_REQUIRED")},
                                                    ]}>
                                                    <Fileupload
                                                        filetype={DocTypes.NATIONAL_ID_FRONT}
                                                        defaultThumbFile={supplierDocs?.nationalID?.frontDoc?.documentPathThumb}
                                                        defaultFile={supplierDocs?.nationalID?.frontDoc?.documentPath}
                                                        fileName={supplierDocs?.nationalID?.frontDoc?.fileName}
                                                        entityId=''
                                                        entityType={EntityTypes.SUPPLIER}
                                                        accessFile={false}
                                                        name={t("KYC_UPLOAD_FRONT_LBL")}
                                                        onChange={(value) => {
                                                            onFileUploadDocs(value, 'nationalIdFront');
                                                        }}
                                                        updateFormValue={(val) => { editSupplierForm.setFieldsValue({ nationalIdFront: val }) }}
                                                    />
                                                </Form.Item> */}
                                                {/* **** OCR File Upload ***** */}
                                                <Form.Item
                                                    name="nationalIdFront"
                                                    className="floating-label-form-item"
                                                    rules={[
                                                    {
                                                        required: true,
                                                        message: t("NATIONAL_ID_FRONT_UPLOAD_REQUIRED"),
                                                    },
                                                    ]}
                                                    valuePropName="value"
                                                    getValueFromEvent={(e) => {
                                                    // if your component emits [ { file, fileThumbUrl } ]
                                                    if (Array.isArray(e) && e.length > 0) {
                                                        return {
                                                        // File: e[0].file,
                                                        // FileThumbURL: e[0].fileThumbUrl,
                                                        };
                                                    }
                                                    return e;
                                                    }}
                                                >
                                                    <OCRFilePreviewUploader
                                                    filetype={DocTypes.NATIONAL_ID_FRONT}
                                                    defaultThumbFile={
                                                        editSupplierDocs?.nationalID?.frontDoc
                                                        ?.documentPathThumb
                                                    }
                                                    defaultFile={
                                                        editSupplierDocs?.nationalID?.frontDoc
                                                        ?.documentPath
                                                    }
                                                    fileName={
                                                        editSupplierDocs?.nationalID?.frontDoc?.fileName
                                                    }
                                                    entityId=""
                                                    entityType={EntityTypes.SUPPLIER}
                                                    accessFile={false}
                                                    // onChange={(value) => {
                                                    //   onFileUploadDocs(value, "vatUpload");
                                                    // }}
                                                    name={t("KYC_UPLOAD_FRONT_LBL")}
                                                    onChange={(newFiles) =>
                                                        handleOCRConformFileChange(
                                                        newFiles,
                                                        "nationalIdFront",
                                                        OCRFieldNames.NATIONAL_ID,
                                                        DocTypes.NATIONAL_ID_FRONT
                                                        )
                                                    }
                                                    onDelete={() =>
                                                        handleEditingDeleteFile(
                                                        "nationalIdFront",
                                                        OCRFieldNames.NATIONAL_ID
                                                        )
                                                    }
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                {/* <Form.Item name="nationalIdBack" className="floating-label-form-item"
                                                    rules={[
                                                        { required: true, message:t("NATIONAL_ID_BACK_UPLOAD_REQUIRED")},
                                                    ]}>

                                                    <Fileupload
                                                        filetype={DocTypes.NATIONAL_ID_BACK}
                                                        defaultThumbFile={supplierDocs?.nationalID?.backDoc?.documentPathThumb}
                                                        defaultFile={supplierDocs?.nationalID?.backDoc?.documentPath}
                                                        fileName={supplierDocs?.nationalID?.backDoc?.fileName}
                                                        entityId=''
                                                        entityType={EntityTypes.SUPPLIER}
                                                        accessFile={false}
                                                        name={t("KYC_UPLOAD_BACK_LBL")}
                                                        onChange={(value) => {
                                                            onFileUploadDocs(value, 'nationalIdBack');
                                                        }}
                                                        updateFormValue={(val) => { editSupplierForm.setFieldsValue({ nationalIdBack: val }) }}
                                                    />
                                                </Form.Item> */}
                                                {/* **** OCR File Upload ***** */}
                                                <Form.Item
                                                    name="nationalIdBack"
                                                    className="floating-label-form-item"
                                                    rules={[
                                                    {
                                                        required: true,
                                                        message: t("NATIONAL_ID_BACK_UPLOAD_REQUIRED"),
                                                    },
                                                    ]}
                                                    valuePropName="value"
                                                    getValueFromEvent={(e) => {
                                                    // if your component emits [ { file, fileThumbUrl } ]
                                                    if (Array.isArray(e) && e.length > 0) {
                                                        return {
                                                        // File: e[0].file,
                                                        // FileThumbURL: e[0].fileThumbUrl,
                                                        };
                                                    }
                                                    return e;
                                                    }}
                                                >
                                                    <OCRFilePreviewUploader
                                                    filetype={DocTypes.NATIONAL_ID_BACK}
                                                    defaultThumbFile={
                                                        editSupplierDocs?.nationalID?.backDoc
                                                        ?.documentPathThumb
                                                    }
                                                    defaultFile={
                                                        editSupplierDocs?.nationalID?.backDoc
                                                        ?.documentPath
                                                    }
                                                    fileName={
                                                        editSupplierDocs?.nationalID?.backDoc?.fileName
                                                    }
                                                    entityId=""
                                                    entityType={EntityTypes.SUPPLIER}
                                                    accessFile={false}
                                                    // onChange={(value) => {
                                                    //   onFileUploadDocs(value, "vatUpload");
                                                    // }}
                                                    name={t("KYC_UPLOAD_BACK_LBL")}
                                                    onChange={(newFiles) =>
                                                        handleOCRConformFileChange(
                                                        newFiles,
                                                        "nationalIdBack",
                                                        OCRFieldNames.NATIONAL_ID,
                                                        DocTypes.NATIONAL_ID_BACK
                                                        )
                                                    }
                                                    onDelete={() =>
                                                        handleEditingDeleteFile(
                                                        "nationalIdBack",
                                                        OCRFieldNames.NATIONAL_ID
                                                        )
                                                    }
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <Form.Item
                                            name="nationalId"
                                            rules={[{ required: true, message: t("NATIONAL_ID_REQUIRED") },
                                            { validator: validateNotEmpty('national Id') },
                                            uniqueDocNumberRule("nationalId")
                                            ]}
                                            className="floating-label-form-item"
                                        >
                                            <Input value={editSupplierForm.getFieldValue("nationalId")} maxLength={20} style={{ width: '100%' }} className="floating-input" placeholder="Enter National ID Number"
                                                onChange={(e) => handleFormChange("nationalId", e.target.value)}
                                            />
                                            <label className="floating-label">{t("FLEET_DRIVER_NATIONAL_ID")} <span>*</span></label>
                                        </Form.Item>
                                        <Form.Item
                                            name="nationalIdExpiry"
                                            rules={[{ required: true, message: t("EXPIRY_DATE_YOUR_REQUIRED") }]}
                                            className="floating-label-form-item"
                                        >
                                            <DatePicker className="floating-input" format={format} placeholder={t("EXPIRY_DATE_ENTER_PLACEHOLDER")} disabledDate={disablePastDates}
                                                value={editSupplierForm.getFieldValue("nationalIdExpiry") ? dayjs(editSupplierForm.getFieldValue("nationalIdExpiry"), format) : null}
                                                onChange={(date, dateString) => handleFormChange("nationalIdExpiry", dateString)}
                                            />
                                            <label className="floating-label">{t("FLEET_DRIVER_EXPIRY_DATE")} <span>*</span></label>
                                        </Form.Item>
                                        {/* **********  Edit PASSPORT  ********** */}
                                        {detailData?.serviceTypes?.length > 0 && detailData?.serviceTypes?.includes("CrossBorder") ?
                                            <>
                                            <span className='star-color'>{t("FLEET_DRIVER_PASSPORT")} <span>*</span></span>
                                            <Row gutter={16}>
                                                <Col span={12}>
                                                    {/* <Form.Item name="passportFront" className="floating-label-form-item"
                                                        rules={[
                                                            { required: true, message: t("PASSPORT_FRONT_UPLOAD_REQUIRED") },
                                                        ]}>
                                                        <Fileupload
                                                            filetype={DocTypes.PASSPORT_FRONT}
                                                            defaultThumbFile={supplierDocs?.passport?.frontDoc?.documentPathThumb}
                                                            defaultFile={supplierDocs?.passport?.frontDoc?.documentPath}
                                                            fileName={supplierDocs?.passport?.frontDoc?.fileName}
                                                            entityId=''
                                                            entityType={EntityTypes.SUPPLIER}
                                                            accessFile={false}
                                                            name={t("KYC_UPLOAD_FRONT_LBL")}
                                                            onChange={(value) => {
                                                                onFileUploadDocs(value, 'passportFront');
                                                            }}
                                                            updateFormValue={(val) => { editSupplierForm.setFieldsValue({ passportFront: val }) }}
                                                        />
                                                    </Form.Item> */}
                                                    {/* **** OCR File Upload PASSPORT FRONT***** */}
                                                    <Form.Item
                                                    name="passportFront"
                                                    className="floating-label-form-item"
                                                    rules={[
                                                        {
                                                        required: true,
                                                        message: t("PASSPORT_FRONT_UPLOAD_REQUIRED"),
                                                        },
                                                    ]}
                                                    valuePropName="value"
                                                    getValueFromEvent={(e) => {
                                                        // if your component emits [ { file, fileThumbUrl } ]
                                                        if (Array.isArray(e) && e.length > 0) {
                                                        return {
                                                            // File: e[0].file,
                                                            // FileThumbURL: e[0].fileThumbUrl,
                                                        };
                                                        }
                                                        return e;
                                                    }}
                                                    >
                                                    <OCRFilePreviewUploader
                                                        filetype={DocTypes.PASSPORT_FRONT}
                                                        defaultThumbFile={
                                                        editSupplierDocs?.passport?.frontDoc
                                                            ?.documentPathThumb
                                                        }
                                                        defaultFile={
                                                        editSupplierDocs?.passport?.frontDoc
                                                            ?.documentPath
                                                        }
                                                        fileName={
                                                        editSupplierDocs?.passport?.frontDoc?.fileName
                                                        }
                                                        entityId=""
                                                        entityType={EntityTypes.SUPPLIER}
                                                        accessFile={false}
                                                        // onChange={(value) => {
                                                        //   onFileUploadDocs(value, "vatUpload");
                                                        // }}
                                                        name={t("KYC_UPLOAD_FRONT_LBL")}
                                                        onChange={(newFiles) =>
                                                        handleOCRConformFileChange(
                                                            newFiles,
                                                            "passportFront",
                                                            OCRFieldNames.PASSPORT,
                                                            DocTypes.PASSPORT_FRONT
                                                        )
                                                        }
                                                        onDelete={() =>
                                                        handleEditingDeleteFile(
                                                            "passportFront",
                                                            OCRFieldNames.PASSPORT
                                                        )
                                                        }
                                                    />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={12}>
                                                    {/* <Form.Item name="passportBack" className="floating-label-form-item"
                                                        rules={[
                                                            { required: true, message: t("PASSPORT_BACK_UPLOAD_REQUIRED") },
                                                        ]}>
                                                        <Fileupload
                                                            filetype={DocTypes.PASSPORT_BACK}
                                                            defaultThumbFile={supplierDocs?.passport?.backDoc?.documentPathThumb}
                                                            defaultFile={supplierDocs?.passport?.backDoc?.documentPath}
                                                            fileName={supplierDocs?.passport?.backDoc?.fileName}
                                                            entityId=''
                                                            entityType={EntityTypes.SUPPLIER}
                                                            accessFile={false}
                                                            name={t("KYC_UPLOAD_BACK_LBL")}
                                                            onChange={(value) => {
                                                                onFileUploadDocs(value, 'passportBack');
                                                            }}
                                                            updateFormValue={(val) => { editSupplierForm.setFieldsValue({ passportBack: val }) }}
                                                        />

                                                    </Form.Item> */}
                                                    {/* **** OCR File Upload PASSPORT BACK***** */}
                                                    <Form.Item
                                                    name="passportBack"
                                                    className="floating-label-form-item"
                                                    rules={[
                                                        {
                                                        required: true,
                                                        message: t("PASSPORT_BACK_UPLOAD_REQUIRED"),
                                                        },
                                                    ]}
                                                    valuePropName="value"
                                                    getValueFromEvent={(e) => {
                                                        // if your component emits [ { file, fileThumbUrl } ]
                                                        if (Array.isArray(e) && e.length > 0) {
                                                        return {
                                                            // File: e[0].file,
                                                            // FileThumbURL: e[0].fileThumbUrl,
                                                        };
                                                        }
                                                        return e;
                                                    }}
                                                    >
                                                    <OCRFilePreviewUploader
                                                        filetype={DocTypes.PASSPORT_BACK}
                                                        defaultThumbFile={
                                                        editSupplierDocs?.passport?.backDoc
                                                            ?.documentPathThumb
                                                        }
                                                        defaultFile={
                                                        editSupplierDocs?.passport?.backDoc
                                                            ?.documentPath
                                                        }
                                                        fileName={
                                                        editSupplierDocs?.passport?.backDoc?.fileName
                                                        }
                                                        entityId=""
                                                        entityType={EntityTypes.SUPPLIER}
                                                        accessFile={false}
                                                        // onChange={(value) => {
                                                        //   onFileUploadDocs(value, "vatUpload");
                                                        // }}
                                                        name={t("KYC_UPLOAD_BACK_LBL")}
                                                        onChange={(newFiles) =>
                                                        handleOCRConformFileChange(
                                                            newFiles,
                                                            "passportBack",
                                                            OCRFieldNames.PASSPORT,
                                                            DocTypes.PASSPORT_BACK
                                                        )
                                                        }
                                                        onDelete={() =>
                                                        handleEditingDeleteFile(
                                                            "passportBack",
                                                            OCRFieldNames.PASSPORT
                                                        )
                                                        }
                                                    />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Form.Item
                                                name="passportNumber"
                                                rules={[{ required: true, message:t("PASSPORT_NO_REQUIRED") },
                                                { validator: validateNotEmpty('passport number') },
                                                uniqueDocNumberRule("passportNumber")
                                                ]}
                                                className="floating-label-form-item"
                                            >
                                                <Input value={editSupplierForm.getFieldValue("passportNumber")} maxLength={20} style={{ width: '100%' }} className="floating-input" placeholder="Enter Passport Number"
                                                    onChange={(e) => handleFormChange("passportNumber", e.target.value)} />
                                                <label className="floating-label">{t("FLEET_DRIVER_PASSPORT_NO")}<span>*</span></label>
                                            </Form.Item>
                                            <Form.Item
                                                name="passportExpiry"
                                                rules={[{ required: true, message: t("EXPIRY_DATE_YOUR_REQUIRED") }]}
                                                className="floating-label-form-item"
                                            >
                                                <DatePicker className="floating-input" format={format} placeholder={t("EXPIRY_DATE_ENTER_PLACEHOLDER")} disabledDate={disablePastDates}
                                                    value={editSupplierForm.getFieldValue("passportExpiry") ? dayjs(editSupplierForm.getFieldValue("passportExpiry"), format) : null}
                                                    onChange={(date, dateString) => handleFormChange("passportExpiry", dateString)}
                                                />
                                                <label className="floating-label">{t("FLEET_DRIVER_EXPIRY_DATE")} <span>*</span></label>
                                            </Form.Item>
                                            <span className='star-color'>{t("FLEET_DRIVER_VISA")} <span></span></span>
                                            {visa?.map((data, index) =>
                                                <div key={index}>
                                                    {(visa?.length > 1 && index !== 0) &&
                                                        <Row justify={'end'} className='delete-visa' onClick={() => {
                                                            const updatedVisa = [...visa];
                                                            updatedVisa.splice(index, 1);
                                                            setVisa(updatedVisa);
                                                        }}
                                                        >
                                                            {t("ACCOUNT_REMOVE")}
                                                        </Row>
                                                    }
                                                    {/* <Form.Item className="floating-label-form-item">
                                                        <Fileupload
                                                            filetype={DocTypes.VISA_FRONT}
                                                            defaultThumbFile={data?.frontDoc?.documentPathThumb}
                                                            defaultFile={data?.frontDoc?.documentPath}
                                                            fileName={data?.frontDoc?.fileName}
                                                            entityId={""}
                                                            entityType={EntityTypes.SUPPLIER}
                                                            accessFile={false}
                                                            onChange={(value) => {
                                                                handleVisa(value, index)
                                                            }}
                                                        // updateFormValue={(val) => { editSupplierForm.setFieldsValue({ visaFront: val }) }}
                                                        />
                                                    </Form.Item> */}

                                                    <Form.Item
                                                        className="floating-label-form-item"
                                                        valuePropName="value"
                                                        getValueFromEvent={(e) => {
                                                        // if your component emits [ { file, fileThumbUrl } ]
                                                        if (Array.isArray(e) && e.length > 0) {
                                                            return {
                                                            // File: e[0].file,
                                                            // FileThumbURL: e[0].fileThumbUrl,
                                                            };
                                                        }
                                                        return e;
                                                        }}
                                                    >
                                                        <OCRFilePreviewUploader
                                                        filetype={DocTypes.VISA_FRONT}
                                                        defaultThumbFile={
                                                            data.frontDoc?.documentPathThumb
                                                        }
                                                        defaultFile={data.frontDoc?.documentPath}
                                                        fileName={data.frontDoc?.fileName}
                                                        entityId={""}
                                                        entityType={EntityTypes.SUPPLIER}
                                                        accessFile={false}
                                                        name={t("KYC_UPLOAD_BACK_LBL")}
                                                        onChange={(newFiles) =>
                                                            handleOCRConformFileChange(
                                                            newFiles,
                                                            "visa",
                                                            OCRFieldNames.VISA,
                                                            DocTypes.VISA_FRONT,
                                                            index
                                                            )
                                                        }
                                                        onDelete={() =>
                                                            handleVisaDeleteFileUpload(index)
                                                        }
                                                        />
                                                    </Form.Item>

                                                    <Form.Item
                                                        className="floating-label-form-item"
                                                        //   name={"visa_" + index + "_issuingCountry"}
                                                        name={["visa", index, "issuingCountry"]}
                                                        // rules={[
                                                        //     {
                                                        //         required: true,
                                                        //         message: t("ISSUE_COUNTRY_VALIDATION"),
                                                        //     },
                                                        // ]}
                                                    >
                                                        <Select
                                                            name="issuingCountry"
                                                            className="floating-selectt"
                                                            options={countryOptions}
                                                            showSearch
                                                            placeholder={t("ISSUING_COUNTRY_PLACEHOLDER")}
                                                            value={data?.issuingCountry}
                                                            fieldNames={{ label: "name", value: "name" }}
                                                            onChange={(value) => {
                                                                //   addDriverForm.setFieldsValue({
                                                                //     ["visa_" + index + "_issuingCountry"]: value,
                                                                //   });
                                                                //   handleFormChange("visa_" + index + "_issuingCountry", value);
                                                                handleVisa({ issuingCountry: value }, index);
                                                            }}
                                                            loading={issuingCountriesListWaiter}
                                                            filterOption={(input, option) =>
                                                                option.name
                                                                    .toLowerCase()
                                                                    .indexOf(input.toLowerCase()) >= 0
                                                            }
                                                        />
                                                        <label className="floating-label">
                                                            {t("ACCOUNT_ISSUNING_COUNTRY")} <span></span>
                                                        </label>
                                                    </Form.Item>
                                                    <Form.Item className="floating-label-form-item" 
                                                 name={["visa", index, "documentNumber"]}
                                                    rules={[uniqueDocNumberRule(["visa",index,"documentNumber"])]}
                                                    >
                                                        <Input value={data?.documentNumber || ""} style={{ width: '100%' }} maxLength={20} className="floating-input" placeholder="Enter Visa Number"
                                                            onChange={(e) => { handleFormChange("documentNumber", e.target.value); handleVisa({ documentNumber: e.target.value }, index) }}
                                                        />
                                                        <label className="floating-label">{t("FLEET_DRIVER_VISA_NO")} <span></span></label>
                                                    </Form.Item>
                                                    <Form.Item className="floating-label-form-item">
                                                        <DatePicker className="floating-input" format={format} placeholder={t("EXPIRY_DATE_ENTER_PLACEHOLDER")} disabledDate={disablePastDates}
                                                            value={data?.expiryDate ? dayjs(data.expiryDate, 'YYYY-MM-DD').isValid() ? dayjs(data.expiryDate, 'YYYY-MM-DD') : dayjs(data.expiryDate, 'DD/MM/YYYY') : null}
                                                            onChange={(date, dateString) => { handleFormChange("expiryDate", dateString); handleVisa({ expiryDate: dateString }, index) }}
                                                        />
                                                        <label className="floating-label">{t("FLEET_DRIVER_EXPIRY_DATE")} <span></span></label>
                                                    </Form.Item>
                                                </div>
                                            )}
                                            <Button type='secondary'
                                                icon={<PlusOutlined />}
                                                className="add-doc"
                                                onClick={addVisa}
                                            >
                                                {/* {t("KYC_INFO_ADD_VISA")} */}
                                                {t("ACCOUNT_ADD_DOC")}
                                            </Button>
                                        </>
                                            :
                                           <></>
                                        }
                                    </>
                                }
                            </div>
                        </Form>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
                        <Button loading={isbtnLoader} onClick={handleEditSupplier}>
                           {t("SAVE_SUPPLIER_COMMON_BTN")}
                        </Button>
                    </div>
                </Modal>

            )}
             {/* ************* VERIFY MODAL *********** */}
            {verifyModal &&
                <Modal open={verifyModal} className='supplier-detail-otp-verification-modal' centered maskClosable={false} onCancel={() => { setVerifyModal(false) }} width={"30rem"}
                    title={<Row justify={'center'} style={{ fontSize: "18px" }}>{t("OTP_VERIFICATION_KEY")}</Row>}
                    footer={false}>
                    <div className="verify-modal-wrapper">
                        <Form form={form} name='otpverification'>
                            <Row justify={'center'} >
                                <Col span={7} style={{ paddingRight: '10px' }}>
                                    <Form.Item
                                        rules={[{ required: true, message: t("COUNTRY_CODE_REQUIRED") }]}
                                        name="countryCode"
                                        className="floating-label-form-item"
                                    >
                                        <Select showSearch className="floating-select country-code-select" popupClassName="country-code-popup" placeholder="+355" disabled={true} value={detailData?.countryCode}
                                            fieldNames={{
                                                label: "label",
                                                value: "phone_code",
                                            }}
                                        />
                                        <label className="floating-label">{t("COUNTRY_CODE_LBL")} <b className="mandate-color">*</b></label>
                                    </Form.Item>
                                </Col>
                                <Col span={17}>
                                    <Form.Item
                                        rules={[
                                            { required: true, message: t("MOBILE_NO_REQUIRED"), },
                                            {
                                                pattern: /^[0-9]*$/,
                                                message: t("MOBILE_NO_VALIDATION_REQUIRED"),
                                            },
                                        ]}
                                        name="mobileNumber"
                                        className="floating-label-form-item">
                                        <Input placeholder={t("FORGOT_PH_MOBILE_NO")} value={detailData?.mobileNo} disabled={true}
                                            className="floating-input-basic"
                                        />
                                        <label className="floating-label">{t("FORGOT_LBL_MOBILE_NO")} <b className="mandate-color">*</b></label>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <div className='four-digit'>{t("ENTER_FOUR_DIGIT_OTP")}</div>
                            <Form.Item name="otpNumber" rules={[{ required: true, message: t("PIN_REQUIRED") }]} >
                                <Input.OTP style={{ width: '150px', }} length={4} onChange={(e) => {
                                    form.setFieldValue("otpNumber", e);
                                    form.validateFields();
                                }} />
                            </Form.Item>
                            {isOTPRequested && <span onClick={onResendOTP} className={'resend-otp'}>{timer === 0 ? t("RESEND_OTP_KEY") : `${t("RESEND_OTP_IN_KEY")} ${timer}s`}</span>
                            }
                        </Form>
                        <div className='button-row'>
                            <Button type='secondary' disabled={isbtnLoader||isDisableOtpAction} className="cancel-btn" onClick={() => { setVerifyModal(false) }}> {t("COMMON_CANCEL_BTN")}</Button>
                            <Button type='secondary' loading={isbtnLoader} disabled={isDisableOtpAction} className="submit-btn" onClick={verifyOTPHandler}>{t("VERIFY_KEY")}</Button>
                        </div>
                    </div>
                </Modal>

            }
            <Modal className="change-mobile-modal"
                title={
                    <div style={{ fontWeight: "bold", fontSize: "20px" }}>
                        {t("UPLOAD_PROFILE_PIC_KEY")}
                    </div>
                }
                open={isUploadImage}
                onCancel={() => setIsUploadImage(false)}
                footer={false}
            ><br />

                <Form form={uploadImageForm} name="uploadImageForm">
                    <Form.Item name="uploadImage" className="floating-label-form-item"
                        rules={[
                            { required: true, message: t("UPLOAD_PROFILE_PIC_MSG") },
                        ]}>
                        <Fileupload
                            defaultThumbFile={documentUtility.getThumbnailImagePath(uploadImageForm.getFieldValue("uploadImage")?.fileThumbUrl)}
                            defaultFile={uploadImageForm.getFieldValue("uploadImage")?.fileUrl}
                            filetype={DocTypes?.PROFILE_PIC}
                            fileName={uploadImageForm.getFieldValue("uploadImage")?.fileName}
                            entityId=''
                            entityType={EntityTypes.SUPPLIER}
                            accessFile={true}
                            name={t("KYC_UPLOAD_FRONT_LBL")}
                            onChange={(value) => {
                                onProfilePictureUpload(value, 'uploadImage');
                                //kycForm.setFieldsValue({ licenceFront: value });
                            }}
                        // updateFormValue={(val)=>{ kycForm.setFieldsValue({ licenceFront: val })}}
                        />
                    </Form.Item>
                </Form>

                <div className="mobile-change-footer">
                    <Button className="mobile-change-button" key="cancel" disabled={imageUploadLoader} onClick={() => setIsUploadImage(false)}>
                        {t("COMMON_CANCEL_BTN")}
                    </Button>
                    <Button className="mobile-change-button"
                        loading={imageUploadLoader}
                        key="submit"
                        type="primary"
                        onClick={handleUploadProfile}
                    >
                        {t("COMMON_SUBMIT_BTN")}
                    </Button></div>
            </Modal>

                  {/* **************Uploading OCR Loading *****************/}
                  <Modal
                    open={isUploadingPopupVisible}
                    footer={null}
                    closable={false}
                    // onCancel={() => setIsUploadingPopupVisible(false)}
                    centered
                    width={352}
                    style={{
                      textAlign: "center",
                      padding: "32px 16px",
                      zIndex: "2000000 !important",
                      position: "relative",
                    }}
                  >
                    <h3
                      style={{
                        fontWeight: "600",
                        fontSize: "18px",
                        lineHeight: "1.5",
                        margin: 0,
                      }}
                    >
                      Uploading and processing documents
                    </h3>
                    <div style={{ margin: "12px 0" }}>
                      <img
                        // src={logo}
                        src={fileSearchGif}
                        alt="File Search"
                        style={{ width: 112, height: 112 }}
                      ></img>
                    </div>
            
                    <p
                      style={{
                        fontWeight: "500",
                        fontSize: "14px",
                        margin: 0,
                        color: "#2C3A4BE5",
                      }}
                    >
                      {uploadState.status}
                    </p>
                    <p
                      style={{
                        color: "#394452",
                        fontSize: "12px",
                        marginTop: "8px",
                        marginBottom: 0,
                        color: "#394452CC",
                      }}
                    >
                      {uploadState.description}
                    </p>
                  </Modal>
        </>
    )
}